import { Country } from '../types';

export const americasData: Country[] = [
  {
    "code": "AI",
    "name": "Anguilla",
    "nameAr": "أنغيلا",
    "nameFr": "Anguilla",
    "cities": [
            {
                  "name": "Barbuda",
                  "nameAr": "Barbuda",
                  "nameFr": "Barbuda"
            },
            {
                  "name": "Redonda",
                  "nameAr": "Round",
                  "nameFr": "Redonda"
            },
            {
                  "name": "Saint George",
                  "nameAr": "Saint George",
                  "nameFr": "Saint George"
            },
            {
                  "name": "Saint John",
                  "nameAr": "Saint John",
                  "nameFr": "Saint John"
            },
            {
                  "name": "Saint Mary",
                  "nameAr": "Saint Mary",
                  "nameFr": "Saint Mary"
            },
            {
                  "name": "Saint Paul",
                  "nameAr": "Saint Paul",
                  "nameFr": "Saint Paul"
            },
            {
                  "name": "Saint Peter",
                  "nameAr": "Saint Peter",
                  "nameFr": "Saint Peter"
            },
            {
                  "name": "Saint Philip",
                  "nameAr": "Saint Philip",
                  "nameFr": "Saint Philip"
            }
      ]
  },
  {
    "code": "AG",
    "name": "Antigua and Barbuda",
    "nameAr": "أنتيغوا وباربودا",
    "nameFr": "Antigua and Barbuda",
    "cities": [
      {
        "name": "Saint John",
        "nameAr": "القديس يوحنا",
        "nameFr": "Saint Jean"
      },
      {
        "name": "Saint Paul",
        "nameAr": "القديس بول",
        "nameFr": "Saint Paul"
      },
      {
        "name": "Saint George",
        "nameAr": "القديس جورج",
        "nameFr": "Saint George"
      },
      {
        "name": "Saint Peter",
        "nameAr": "القديس بطرس",
        "nameFr": "Saint Pierre"
      },
      {
        "name": "Saint Mary",
        "nameAr": "القديس ماري",
        "nameFr": "Sainte Marie"
      },
      {
        "name": "Barbuda",
        "nameAr": "باربودا",
        "nameFr": "Barbuda"
      },
      {
        "name": "Saint Philip",
        "nameAr": "سانت فيليب",
        "nameFr": "Saint philippe"
      }
    ]
  },
  {
    "code": "AR",
    "name": "Argentina",
    "nameAr": "الأرجنتين",
    "nameFr": "Argentina",
    "cities": [
      {
        "name": "Buenos Aires",
        "nameAr": "بوينس آيرس",
        "nameFr": "Buenos Aires"
      },
      {
        "name": "Cordoba",
        "nameAr": "قرطبة",
        "nameFr": "Cordoba"
      },
      {
        "name": "Entre Rios",
        "nameAr": "انتري ريوس",
        "nameFr": "Entre Rios"
      },
      {
        "name": "Salta",
        "nameAr": "سالتا",
        "nameFr": "Salta"
      },
      {
        "name": "Jujuy",
        "nameAr": "خوخوي",
        "nameFr": "Jujuy"
      },
      {
        "name": "La Pampa",
        "nameAr": "لا بامبا",
        "nameFr": "La Pampa"
      },
      {
        "name": "Mendoza",
        "nameAr": "مندوزا",
        "nameFr": "Mendoza"
      },
      {
        "name": "Misiones",
        "nameAr": "ميسيونيس",
        "nameFr": "Misiones"
      },
      {
        "name": "Santa Cruz",
        "nameAr": "سانتا كروز",
        "nameFr": "Santa Cruz"
      },
      {
        "name": "Santa Fe",
        "nameAr": "سانتا في",
        "nameFr": "Santa Fe"
      },
      {
        "name": "Tucuman",
        "nameAr": "توكومان",
        "nameFr": "Tucuman"
      },
      {
        "name": "Corrientes",
        "nameAr": "كورينتس",
        "nameFr": "Corrientes"
      },
      {
        "name": "San Juan",
        "nameAr": "سان خوان",
        "nameFr": "San Juan"
      },
      {
        "name": "Santiago del Estero",
        "nameAr": "سانتياغو ديل إستيرو",
        "nameFr": "Santiago del Estero"
      },
      {
        "name": "Catamarca",
        "nameAr": "كاتاماركا",
        "nameFr": "Catamarca"
      },
      {
        "name": "Neuquen",
        "nameAr": "نيوكوين",
        "nameFr": "Neuquen"
      },
      {
        "name": "Distrito Federal",
        "nameAr": "وفي مقاطعة الاتحادية",
        "nameFr": "Distrito Federal"
      },
      {
        "name": "La Rioja",
        "nameAr": "لا ريوخا",
        "nameFr": "La Rioja"
      },
      {
        "name": "Rio Negro",
        "nameAr": "ريو نيغرو",
        "nameFr": "Rio Negro"
      },
      {
        "name": "Chubut",
        "nameAr": "شوبوت",
        "nameFr": "Chubut"
      },
      {
        "name": "San Luis",
        "nameAr": "سان لويس",
        "nameFr": "San Luis"
      },
      {
        "name": "Tierra del Fuego",
        "nameAr": "تييرا ديل فويغو",
        "nameFr": "Terre de Feu"
      },
      {
        "name": "Formosa",
        "nameAr": "فورموزا",
        "nameFr": "Formose"
      },
      {
        "name": "Chaco",
        "nameAr": "شاكو",
        "nameFr": "Chaco"
      }
    ]
  },
  {
    "code": "AW",
    "name": "Aruba",
    "nameAr": "أروبا",
    "nameFr": "Aruba",
    "cities": [
            {
                  "name": "Autonomous City of Buenos Aires",
                  "nameAr": "Ciudad autónoma de Buenos Aires",
                  "nameFr": "Autonomous City of Buenos Aires"
            },
            {
                  "name": "Buenos Aires",
                  "nameAr": "Buenos Aires",
                  "nameFr": "Buenos Aires"
            },
            {
                  "name": "Catamarca",
                  "nameAr": "Catamarca",
                  "nameFr": "Catamarca"
            },
            {
                  "name": "Chaco",
                  "nameAr": "Chaco",
                  "nameFr": "Chaco"
            },
            {
                  "name": "Chubut",
                  "nameAr": "Chubut",
                  "nameFr": "Chubut"
            },
            {
                  "name": "Córdoba",
                  "nameAr": "Córdoba",
                  "nameFr": "Córdoba"
            },
            {
                  "name": "Corrientes",
                  "nameAr": "Corrientes",
                  "nameFr": "Corrientes"
            },
            {
                  "name": "Entre Ríos",
                  "nameAr": "Entre Ríos",
                  "nameFr": "Entre Ríos"
            },
            {
                  "name": "Formosa",
                  "nameAr": "Formosa",
                  "nameFr": "Formosa"
            },
            {
                  "name": "Jujuy",
                  "nameAr": "Jujuy",
                  "nameFr": "Jujuy"
            },
            {
                  "name": "La Pampa",
                  "nameAr": "La Pampa",
                  "nameFr": "La Pampa"
            },
            {
                  "name": "La Rioja",
                  "nameAr": "La Rioja",
                  "nameFr": "La Rioja"
            },
            {
                  "name": "Mendoza",
                  "nameAr": "Mendoza",
                  "nameFr": "Mendoza"
            },
            {
                  "name": "Misiones",
                  "nameAr": "Misiones",
                  "nameFr": "Misiones"
            },
            {
                  "name": "Neuquén",
                  "nameAr": "Neuquén",
                  "nameFr": "Neuquén"
            },
            {
                  "name": "Río Negro",
                  "nameAr": "Río Negro",
                  "nameFr": "Río Negro"
            },
            {
                  "name": "Salta",
                  "nameAr": "Salta",
                  "nameFr": "Salta"
            },
            {
                  "name": "San Juan",
                  "nameAr": "San Juan",
                  "nameFr": "San Juan"
            },
            {
                  "name": "San Luis",
                  "nameAr": "San Luis",
                  "nameFr": "San Luis"
            },
            {
                  "name": "Santa Cruz",
                  "nameAr": "Santa Cruz",
                  "nameFr": "Santa Cruz"
            },
            {
                  "name": "Santa Fe",
                  "nameAr": "Santa Fe",
                  "nameFr": "Santa Fe"
            },
            {
                  "name": "Santiago del Estero",
                  "nameAr": "Santiago del Estero",
                  "nameFr": "Santiago del Estero"
            },
            {
                  "name": "Tierra del Fuego",
                  "nameAr": "Tierra del Fuego",
                  "nameFr": "Tierra del Fuego"
            },
            {
                  "name": "Tucumán",
                  "nameAr": "Tucumán",
                  "nameFr": "Tucumán"
            }
      ]
  },
  {
    "code": "BB",
    "name": "Barbados",
    "nameAr": "بربادوس",
    "nameFr": "Barbados",
    "cities": [
      {
        "name": "Saint Joseph",
        "nameAr": "القديس يوسف",
        "nameFr": "Saint Joseph"
      },
      {
        "name": "Saint Lucy",
        "nameAr": "سانت لوسي",
        "nameFr": "Sainte Lucie"
      },
      {
        "name": "Saint Thomas",
        "nameAr": "سانت توماس",
        "nameFr": "Saint thomas"
      },
      {
        "name": "Saint James",
        "nameAr": "جيمس قديس",
        "nameFr": "Saint James"
      },
      {
        "name": "Saint John",
        "nameAr": "القديس يوحنا",
        "nameFr": "Saint Jean"
      },
      {
        "name": "Saint Peter",
        "nameAr": "القديس بطرس",
        "nameFr": "Saint Pierre"
      },
      {
        "name": "Christ Church",
        "nameAr": "كنيسة المسيح",
        "nameFr": "Christ Church"
      },
      {
        "name": "Saint George",
        "nameAr": "القديس جورج",
        "nameFr": "Saint George"
      },
      {
        "name": "Saint Michael",
        "nameAr": "القديس مايكل",
        "nameFr": "Saint michel"
      },
      {
        "name": "Saint Andrew",
        "nameAr": "القديس أندرو",
        "nameFr": "Saint andrew"
      },
      {
        "name": "Saint Philip",
        "nameAr": "سانت فيليب",
        "nameFr": "Saint philippe"
      }
    ]
  },
  {
    "code": "BZ",
    "name": "Belize",
    "nameAr": "بليز",
    "nameFr": "Belize",
    "cities": [
      {
        "name": "Toledo",
        "nameAr": "توليدو",
        "nameFr": "Toledo"
      },
      {
        "name": "Cayo",
        "nameAr": "كايو",
        "nameFr": "Cayo"
      },
      {
        "name": "Stann Creek",
        "nameAr": "ستان كريك",
        "nameFr": "Stann Creek"
      },
      {
        "name": "Corozal",
        "nameAr": "كوروزال",
        "nameFr": "Corozal"
      },
      {
        "name": "Orange Walk",
        "nameAr": "أورانج ووك",
        "nameFr": "Orange Walk"
      },
      {
        "name": "Belize",
        "nameAr": "بليز",
        "nameFr": "Belize"
      }
    ]
  },
  {
    "code": "BM",
    "name": "Bermuda",
    "nameAr": "برمودا",
    "nameFr": "Bermuda",
    "cities": [
      {
        "name": "Devonshire",
        "nameAr": "ديفونشاير",
        "nameFr": "Devonshire"
      },
      {
        "name": "Paget",
        "nameAr": "باجيت",
        "nameFr": "Paget"
      },
      {
        "name": "Smiths",
        "nameAr": "الحدادون",
        "nameFr": "Smiths"
      },
      {
        "name": "Hamilton",
        "nameAr": "هاميلتون",
        "nameFr": "Hamilton"
      },
      {
        "name": "Warwick",
        "nameAr": "وارويك",
        "nameFr": "Warwick"
      },
      {
        "name": "Sandys",
        "nameAr": "سانديز",
        "nameFr": "Sandys"
      },
      {
        "name": "Saint George",
        "nameAr": "القديس جورج",
        "nameFr": "Saint George"
      },
      {
        "name": "Hamilton",
        "nameAr": "هاميلتون",
        "nameFr": "Hamilton"
      }
    ]
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "nameAr": "بوليفيا",
    "nameFr": "Bolivia",
    "cities": [
      {
        "name": "Santa Cruz",
        "nameAr": "سانتا كروز",
        "nameFr": "Santa Cruz"
      },
      {
        "name": "Pando",
        "nameAr": "باندو",
        "nameFr": "Pando"
      },
      {
        "name": "Tarija",
        "nameAr": "تاريخا",
        "nameFr": "Tarija"
      },
      {
        "name": "La Paz",
        "nameAr": "لاباز",
        "nameFr": "La paz"
      },
      {
        "name": "Oruro",
        "nameAr": "أورورو",
        "nameFr": "Oruro"
      },
      {
        "name": "Cochabamba",
        "nameAr": "كوتشابامبا",
        "nameFr": "Cochabamba"
      },
      {
        "name": "Potosi",
        "nameAr": "بوتوسي",
        "nameFr": "Potosi"
      },
      {
        "name": "Chuquisaca",
        "nameAr": "شوكيساكا",
        "nameFr": "Chuquisaca"
      },
      {
        "name": "El Beni",
        "nameAr": "البنى",
        "nameFr": "El Beni"
      }
    ]
  },
  {
    "code": "BQ",
    "name": "Bonaire, Sint Eustatius and Saba",
    "nameAr": "بونير وسانت أوستاتيوس وسابا",
    "nameFr": "Bonaire, Sint Eustatius and Saba",
    "cities": [
      {
        "name": "Bonaire",
        "nameAr": "",
        "nameFr": "Bonaire"
      },
      {
        "name": "Saba",
        "nameAr": "",
        "nameFr": "Saba"
      },
      {
        "name": "Sint Eustatius",
        "nameAr": "",
        "nameFr": "Sint Eustatius"
      }
    ]
  },
  {
    "code": "BR",
    "name": "Brazil",
    "nameAr": "البرازيل",
    "nameFr": "Brazil",
    "cities": [
      {
        "name": "Santa Catarina",
        "nameAr": "سانتا كاتارينا",
        "nameFr": "Santa Catarina"
      },
      {
        "name": "Mato Grosso do Sul",
        "nameAr": "ماتو جروسو دو سول",
        "nameFr": "Mato Grosso do Sul"
      },
      {
        "name": "Rio Grande do Sul",
        "nameAr": "ريو غراندي دو سول",
        "nameFr": "Rio Grande do Sul"
      },
      {
        "name": "Espirito Santo",
        "nameAr": "اسبيريتو سانتو",
        "nameFr": "Espirito Santo"
      },
      {
        "name": "Bahia",
        "nameAr": "باهيا",
        "nameFr": "Bahia"
      },
      {
        "name": "Rondonia",
        "nameAr": "روندونيا",
        "nameFr": "Rondonia"
      },
      {
        "name": "Minas Gerais",
        "nameAr": "ميناس جيرايس",
        "nameFr": "minas Gerais"
      },
      {
        "name": "Paraiba",
        "nameAr": "بارايبا",
        "nameFr": "Paraiba"
      },
      {
        "name": "Amapa",
        "nameAr": "أمابا",
        "nameFr": "Amapa"
      },
      {
        "name": "Amazonas",
        "nameAr": "أمازوناس",
        "nameFr": "Amazonas"
      },
      {
        "name": "Para",
        "nameAr": "الفقرة",
        "nameFr": "Para"
      },
      {
        "name": "Ceara",
        "nameAr": "سيارا",
        "nameFr": "Ceara"
      },
      {
        "name": "Rio de Janeiro",
        "nameAr": "ريو دي جانيرو",
        "nameFr": "Rio de Janeiro"
      },
      {
        "name": "Goias",
        "nameAr": "غوياس",
        "nameFr": "Goias"
      },
      {
        "name": "Sao Paulo",
        "nameAr": "ساو باولو",
        "nameFr": "Sao Paulo"
      },
      {
        "name": "Parana",
        "nameAr": "بارانا",
        "nameFr": "Parana"
      },
      {
        "name": "Rio Grande do Norte",
        "nameAr": "ريو غراندي دو نورتي",
        "nameFr": "Rio Grande do Norte"
      },
      {
        "name": "Acre",
        "nameAr": "فدان",
        "nameFr": "Acre"
      },
      {
        "name": "Piaui",
        "nameAr": "بياوي",
        "nameFr": "Piaui"
      },
      {
        "name": "Pernambuco",
        "nameAr": "بيرنامبوكو",
        "nameFr": "Pernambouc"
      },
      {
        "name": "Mato Grosso",
        "nameAr": "ماتو جروسو",
        "nameFr": "Mato Grosso"
      },
      {
        "name": "Maranhao",
        "nameAr": "مارانهاو",
        "nameFr": "Maranhao"
      },
      {
        "name": "Tocantins",
        "nameAr": "توكانتينز",
        "nameFr": "Tocantins"
      },
      {
        "name": "Roraima",
        "nameAr": "رورايما",
        "nameFr": "Roraima"
      },
      {
        "name": "Alagoas",
        "nameAr": "ألاغواس",
        "nameFr": "Alagoas"
      },
      {
        "name": "Sergipe",
        "nameAr": "سيرغيبي",
        "nameFr": "Sergipe"
      },
      {
        "name": "Distrito Federal",
        "nameAr": "وفي مقاطعة الاتحادية",
        "nameFr": "Distrito Federal"
      }
    ]
  },
  {
    "code": "CA",
    "name": "Canada",
    "nameAr": "كندا",
    "nameFr": "Canada",
    "cities": [
            {
                  "name": "Christ Church",
                  "nameAr": "Christ Church",
                  "nameFr": "Christ Church"
            },
            {
                  "name": "Saint Andrew",
                  "nameAr": "Saint Andrew",
                  "nameFr": "Saint Andrew"
            },
            {
                  "name": "Saint George",
                  "nameAr": "Saint George",
                  "nameFr": "Saint George"
            },
            {
                  "name": "Saint James",
                  "nameAr": "Saint James",
                  "nameFr": "Saint James"
            },
            {
                  "name": "Saint John",
                  "nameAr": "Saint John",
                  "nameFr": "Saint John"
            },
            {
                  "name": "Saint Joseph",
                  "nameAr": "Saint Joseph",
                  "nameFr": "Saint Joseph"
            },
            {
                  "name": "Saint Lucy",
                  "nameAr": "Saint Lucy",
                  "nameFr": "Saint Lucy"
            },
            {
                  "name": "Saint Michael",
                  "nameAr": "Saint Michael",
                  "nameFr": "Saint Michael"
            },
            {
                  "name": "Saint Peter",
                  "nameAr": "Saint Peter",
                  "nameFr": "Saint Peter"
            },
            {
                  "name": "Saint Philip",
                  "nameAr": "Saint Philip",
                  "nameFr": "Saint Philip"
            },
            {
                  "name": "Saint Thomas",
                  "nameAr": "Saint Thomas",
                  "nameFr": "Saint Thomas"
            }
      ]
  },
  {
    "code": "KY",
    "name": "Cayman Islands",
    "nameAr": "جزر كايمان",
    "nameFr": "Cayman Islands",
    "cities": [
            {
                  "name": "Cayman Brac",
                  "nameAr": "Cayman Brac",
                  "nameFr": "Cayman Brac"
            },
            {
                  "name": "Grand Cayman",
                  "nameAr": "Grand Cayman",
                  "nameFr": "Grand Cayman"
            },
            {
                  "name": "Little Cayman",
                  "nameAr": "Little Cayman",
                  "nameFr": "Little Cayman"
            }
      ]
  },
  {
    "code": "CL",
    "name": "Chile",
    "nameAr": "تشيلي",
    "nameFr": "Chile",
    "cities": [
      {
        "name": "Bio-Bio",
        "nameAr": "بيو بيو",
        "nameFr": "Bio-Bio"
      },
      {
        "name": "Maule",
        "nameAr": "مولي",
        "nameFr": "Maule"
      },
      {
        "name": "Los Lagos",
        "nameAr": "لوس لاغوس",
        "nameFr": "Los Lagos"
      },
      {
        "name": "Tarapaca",
        "nameAr": "تاراباكا",
        "nameFr": "Tarapaca"
      },
      {
        "name": "Valparaiso",
        "nameAr": "فالبارايسو",
        "nameFr": "Valparaiso"
      },
      {
        "name": "Atacama",
        "nameAr": "أتاكاما",
        "nameFr": "Atacama"
      },
      {
        "name": "Coquimbo",
        "nameAr": "كوكيمبو",
        "nameFr": "Coquimbo"
      },
      {
        "name": "Antofagasta",
        "nameAr": "أنتوفاغاستا",
        "nameFr": "Antofagasta"
      },
      {
        "name": "Araucania",
        "nameAr": "أراوكاريا",
        "nameFr": "Araucanie"
      },
      {
        "name": "Aisen del General Carlos Ibanez del Campo",
        "nameAr": "Aisen del General Carlos Ibanez del Campo",
        "nameFr": "Aisen del General Carlos Ibanez del Campo"
      },
      {
        "name": "Region Metropolitana",
        "nameAr": "منطقة متروبوليتانا",
        "nameFr": "Région métropolitaine"
      }
    ]
  },
  {
    "code": "CO",
    "name": "Colombia",
    "nameAr": "كولومبيا",
    "nameFr": "Colombia",
    "cities": [
      {
        "name": "Cundinamarca",
        "nameAr": "كونديناماركا",
        "nameFr": "Cundinamarca"
      },
      {
        "name": "Norte de Santander",
        "nameAr": "نورتي دي سانتاندر",
        "nameFr": "Norte de Santander"
      },
      {
        "name": "Narino",
        "nameAr": "نارينو",
        "nameFr": "Narino"
      },
      {
        "name": "Risaralda",
        "nameAr": "ريزارالدا",
        "nameFr": "Risaralda"
      },
      {
        "name": "Antioquia",
        "nameAr": "أنتيوكيا",
        "nameFr": "Antioquia"
      },
      {
        "name": "Amazonas",
        "nameAr": "أمازوناس",
        "nameFr": "Amazonas"
      },
      {
        "name": "La Guajira",
        "nameAr": "لا غواخيرا",
        "nameFr": "La Guajira"
      },
      {
        "name": "Choco",
        "nameAr": "شوكو",
        "nameFr": "Choco"
      },
      {
        "name": "Cauca",
        "nameAr": "كاوكا",
        "nameFr": "Cauca"
      },
      {
        "name": "Valle del Cauca",
        "nameAr": "فالي ديل كاوكا",
        "nameFr": "Valle del Cauca"
      },
      {
        "name": "Arauca",
        "nameAr": "اروكا",
        "nameFr": "Arauca"
      },
      {
        "name": "Meta",
        "nameAr": "ميتا",
        "nameFr": "Meta"
      },
      {
        "name": "Caqueta",
        "nameAr": "كاكويتا",
        "nameFr": "Caqueta"
      },
      {
        "name": "Casanare",
        "nameAr": "كازاناري",
        "nameFr": "Casanare"
      },
      {
        "name": "Vaupes",
        "nameAr": "فاوبيس",
        "nameFr": "Vaupes"
      },
      {
        "name": "Tolima",
        "nameAr": "توليما",
        "nameFr": "Tolima"
      },
      {
        "name": "Huila",
        "nameAr": "هويلا",
        "nameFr": "Huila"
      },
      {
        "name": "Atlantico",
        "nameAr": "اتلانتيكو",
        "nameFr": "Atlantico"
      },
      {
        "name": "Cordoba",
        "nameAr": "قرطبة",
        "nameFr": "Cordoba"
      },
      {
        "name": "Santander",
        "nameAr": "سانتاندر",
        "nameFr": "Santander"
      },
      {
        "name": "Cesar",
        "nameAr": "سيزار",
        "nameFr": "Cesar"
      },
      {
        "name": "Sucre",
        "nameAr": "سوكري",
        "nameFr": "Sucre"
      },
      {
        "name": "Putumayo",
        "nameAr": "بوتومايو",
        "nameFr": "Putumayo"
      },
      {
        "name": "Guaviare",
        "nameAr": "غوابياري",
        "nameFr": "Guaviare"
      },
      {
        "name": "San Andres y Providencia",
        "nameAr": "San Andres y Providencia",
        "nameFr": "San Andres et Providencia"
      },
      {
        "name": "Vichada",
        "nameAr": "فيتشادا",
        "nameFr": "Vichada"
      },
      {
        "name": "Quindio",
        "nameAr": "كوينديو",
        "nameFr": "Quindio"
      },
      {
        "name": "Guainia",
        "nameAr": "غواينيا",
        "nameFr": "Guainia"
      },
      {
        "name": "Distrito Especial",
        "nameAr": "Distrito Especial",
        "nameFr": "Distrito Especial"
      }
    ]
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "nameAr": "كوستاريكا",
    "nameFr": "Costa Rica",
    "cities": [
      {
        "name": "Guanacaste",
        "nameAr": "غواناكاست",
        "nameFr": "Guanacaste"
      },
      {
        "name": "Limon",
        "nameAr": "ليمون",
        "nameFr": "Limon"
      },
      {
        "name": "Puntarenas",
        "nameAr": "بونتاريناس",
        "nameFr": "Puntarenas"
      },
      {
        "name": "Alajuela",
        "nameAr": "ألاخويلا",
        "nameFr": "Alajuela"
      },
      {
        "name": "Heredia",
        "nameAr": "هيريديا",
        "nameFr": "Heredia"
      },
      {
        "name": "San Jose",
        "nameAr": "سان خوسيه",
        "nameFr": "San Jose"
      },
      {
        "name": "Cartago",
        "nameAr": "قرطاج",
        "nameFr": "Cartago"
      }
    ]
  },
  {
    "code": "CU",
    "name": "Cuba",
    "nameAr": "كوبا",
    "nameFr": "Cuba",
    "cities": [
      {
        "name": "Cienfuegos",
        "nameAr": "سيينفويغوس",
        "nameFr": "Cienfuegos"
      },
      {
        "name": "La Habana",
        "nameAr": "لا هافانا",
        "nameFr": "La Habana"
      },
      {
        "name": "Santiago de Cuba",
        "nameAr": "سانتياغو دي كوبا",
        "nameFr": "Santiago de Cuba"
      },
      {
        "name": "Camaguey",
        "nameAr": "كاماغواي",
        "nameFr": "Camaguey"
      },
      {
        "name": "Ciudad de la Habana",
        "nameAr": "سيوداد دي لا هافانا",
        "nameFr": "Ciudad de la Habana"
      },
      {
        "name": "Villa Clara",
        "nameAr": "فيلا كلارا",
        "nameFr": "Villa Clara"
      },
      {
        "name": "Pinar del Rio",
        "nameAr": "بينار ديل ريو",
        "nameFr": "Pinar del Rio"
      },
      {
        "name": "Matanzas",
        "nameAr": "ماتانزاس",
        "nameFr": "Matanzas"
      },
      {
        "name": "Guantanamo",
        "nameAr": "غوانتانامو",
        "nameFr": "Guantanamo"
      },
      {
        "name": "Las Tunas",
        "nameAr": "لاس توناس",
        "nameFr": "Las Tunas"
      },
      {
        "name": "Ciego de Avila",
        "nameAr": "سييغو دي أفيلا",
        "nameFr": "Ciego de Avila"
      },
      {
        "name": "Sancti Spiritus",
        "nameAr": "سانكتي سبيريتوس",
        "nameFr": "Sancti Spiritus"
      },
      {
        "name": "Holguin",
        "nameAr": "هولغوين",
        "nameFr": "Holguin"
      },
      {
        "name": "Granma",
        "nameAr": "غرانما",
        "nameFr": "Granma"
      },
      {
        "name": "Isla de la Juventud",
        "nameAr": "جزيرة دي لا جوفينتود",
        "nameFr": "Isla de la Juventud"
      }
    ]
  },
  {
    "code": "CW",
    "name": "Curaçao",
    "nameAr": "كوراساو",
    "nameFr": "Curaçao",
    "cities": []
  },
  {
    "code": "DM",
    "name": "Dominica",
    "nameAr": "دومينيكا",
    "nameFr": "Dominica",
    "cities": [
      {
        "name": "Saint Andrew",
        "nameAr": "القديس أندرو",
        "nameFr": "Saint andrew"
      },
      {
        "name": "Saint David",
        "nameAr": "القديس داود",
        "nameFr": "Saint David"
      },
      {
        "name": "Saint Joseph",
        "nameAr": "القديس يوسف",
        "nameFr": "Saint Joseph"
      },
      {
        "name": "Saint George",
        "nameAr": "القديس جورج",
        "nameFr": "Saint George"
      },
      {
        "name": "Saint Patrick",
        "nameAr": "سانت باتريك",
        "nameFr": "Saint Patrick"
      },
      {
        "name": "Saint Peter",
        "nameAr": "القديس بطرس",
        "nameFr": "Saint Pierre"
      },
      {
        "name": "Saint John",
        "nameAr": "القديس يوحنا",
        "nameFr": "Saint Jean"
      },
      {
        "name": "Saint Mark",
        "nameAr": "سان مارك",
        "nameFr": "Saint mark"
      },
      {
        "name": "Saint Paul",
        "nameAr": "القديس بول",
        "nameFr": "Saint Paul"
      },
      {
        "name": "Saint Luke",
        "nameAr": "القديس لوقا",
        "nameFr": "Saint Luc"
      }
    ]
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "nameAr": "جمهورية الدومينيكان",
    "nameFr": "Dominican Republic",
    "cities": [
      {
        "name": "Sanchez Ramirez",
        "nameAr": "سانشيز راميريز",
        "nameFr": "Sanchez Ramirez"
      },
      {
        "name": "Espaillat",
        "nameAr": "إسبايلات",
        "nameFr": "Espaillat"
      },
      {
        "name": "Duarte",
        "nameAr": "دوارتي",
        "nameFr": "Duarte"
      },
      {
        "name": "Samana",
        "nameAr": "سمانا",
        "nameFr": "Samana"
      },
      {
        "name": "Maria Trinidad Sanchez",
        "nameAr": "ماريا ترينيداد سانشيز",
        "nameFr": "Maria Trinidad Sanchez"
      },
      {
        "name": "La Romana",
        "nameAr": "لا رومانا",
        "nameFr": "La Romana"
      },
      {
        "name": "Azua",
        "nameAr": "ازوا",
        "nameFr": "Azua"
      },
      {
        "name": "San Cristobal",
        "nameAr": "سان كريستوبال",
        "nameFr": "San Cristobal"
      },
      {
        "name": "El Seibo",
        "nameAr": "الصيبو",
        "nameFr": "El Seibo"
      },
      {
        "name": "Monte Plata",
        "nameAr": "مونت بلاتا",
        "nameFr": "Monte Plata"
      },
      {
        "name": "Distrito Nacional",
        "nameAr": "Distrito Nacional",
        "nameFr": "Distrito Nacional"
      },
      {
        "name": "Elias Pina",
        "nameAr": "إلياس بينا",
        "nameFr": "Elias Pina"
      },
      {
        "name": "Santiago",
        "nameAr": "سانتياغو",
        "nameFr": "Santiago"
      },
      {
        "name": "Santiago Rodriguez",
        "nameAr": "سانتياغو رودريجيز",
        "nameFr": "Santiago Rodriguez"
      },
      {
        "name": "Peravia",
        "nameAr": "بيرافيا",
        "nameFr": "Peravia"
      },
      {
        "name": "Monte Cristi",
        "nameAr": "مونت كريستي",
        "nameFr": "Monte Cristi"
      },
      {
        "name": "Salcedo",
        "nameAr": "سالسيدو",
        "nameFr": "Salcedo"
      },
      {
        "name": "Puerto Plata",
        "nameAr": "بويرتو بلاتا",
        "nameFr": "Puerto Plata"
      },
      {
        "name": "San Pedro De Macoris",
        "nameAr": "سان بيدرو دي ماكوريس",
        "nameFr": "San Pedro De Macoris"
      },
      {
        "name": "Pedernales",
        "nameAr": "بدرنالس",
        "nameFr": "Pedernales"
      },
      {
        "name": "Independencia",
        "nameAr": "الاستقلال",
        "nameFr": "Independencia"
      },
      {
        "name": "La Vega",
        "nameAr": "لا فيغا",
        "nameFr": "La Vega"
      },
      {
        "name": "Dajabon",
        "nameAr": "داجابون",
        "nameFr": "Dajabon"
      },
      {
        "name": "Hato Mayor",
        "nameAr": "حاتو العمدة",
        "nameFr": "Hato Mayor"
      },
      {
        "name": "Barahona",
        "nameAr": "باراهونا",
        "nameFr": "Barahona"
      },
      {
        "name": "San Juan",
        "nameAr": "سان خوان",
        "nameFr": "San Juan"
      },
      {
        "name": "La Altagracia",
        "nameAr": "لا التاغراسيا",
        "nameFr": "La Altagracia"
      },
      {
        "name": "Valverde",
        "nameAr": "فالفيردي",
        "nameFr": "Valverde"
      },
      {
        "name": "Baoruco",
        "nameAr": "Baoruco",
        "nameFr": "Baoruco"
      },
      {
        "name": "Monsenor Nouel",
        "nameAr": "مونسنور نويل",
        "nameFr": "Mgr Nouel"
      }
    ]
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "nameAr": "الإكوادور",
    "nameFr": "Ecuador",
    "cities": [
      {
        "name": "Azuay",
        "nameAr": "",
        "nameFr": "Azuay"
      },
      {
        "name": "Bolívar",
        "nameAr": "",
        "nameFr": "Bolívar"
      },
      {
        "name": "Cañar",
        "nameAr": "",
        "nameFr": "Cañar"
      },
      {
        "name": "Carchi",
        "nameAr": "",
        "nameFr": "Carchi"
      },
      {
        "name": "Chimborazo",
        "nameAr": "",
        "nameFr": "Chimborazo"
      },
      {
        "name": "Cotopaxi",
        "nameAr": "",
        "nameFr": "Cotopaxi"
      },
      {
        "name": "El Oro",
        "nameAr": "",
        "nameFr": "El Oro"
      },
      {
        "name": "Esmeraldas",
        "nameAr": "",
        "nameFr": "Esmeraldas"
      },
      {
        "name": "Galápagos",
        "nameAr": "",
        "nameFr": "Galápagos"
      },
      {
        "name": "Guayas",
        "nameAr": "",
        "nameFr": "Guayas"
      },
      {
        "name": "Imbabura",
        "nameAr": "",
        "nameFr": "Imbabura"
      },
      {
        "name": "Loja",
        "nameAr": "",
        "nameFr": "Loja"
      },
      {
        "name": "Los Ríos",
        "nameAr": "",
        "nameFr": "Los Ríos"
      },
      {
        "name": "Manabí",
        "nameAr": "",
        "nameFr": "Manabí"
      },
      {
        "name": "Morona-Santiago",
        "nameAr": "",
        "nameFr": "Morona-Santiago"
      },
      {
        "name": "Napo",
        "nameAr": "",
        "nameFr": "Napo"
      },
      {
        "name": "Orellana",
        "nameAr": "",
        "nameFr": "Orellana"
      },
      {
        "name": "Pastaza",
        "nameAr": "",
        "nameFr": "Pastaza"
      },
      {
        "name": "Pichincha",
        "nameAr": "",
        "nameFr": "Pichincha"
      },
      {
        "name": "Santa Elena",
        "nameAr": "",
        "nameFr": "Santa Elena"
      },
      {
        "name": "Santo Domingo de los Tsáchilas",
        "nameAr": "",
        "nameFr": "Santo Domingo de los Tsáchilas"
      },
      {
        "name": "Sucumbíos",
        "nameAr": "",
        "nameFr": "Sucumbíos"
      },
      {
        "name": "Tungurahua",
        "nameAr": "",
        "nameFr": "Tungurahua"
      },
      {
        "name": "Zamora Chinchipe",
        "nameAr": "",
        "nameFr": "Zamora Chinchipe"
      }
    ]
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "nameAr": "السلفادور",
    "nameFr": "El Salvador",
    "cities": [
            {
                  "name": "Ahuachapán",
                  "nameAr": "Ahuachapán",
                  "nameFr": "Ahuachapán"
            },
            {
                  "name": "Cabañas",
                  "nameAr": "Cabañas",
                  "nameFr": "Cabañas"
            },
            {
                  "name": "Chalatenango",
                  "nameAr": "Chalatenango",
                  "nameFr": "Chalatenango"
            },
            {
                  "name": "Cuscatlán",
                  "nameAr": "Cuscatlán",
                  "nameFr": "Cuscatlán"
            },
            {
                  "name": "La Libertad",
                  "nameAr": "La Libertad",
                  "nameFr": "La Libertad"
            },
            {
                  "name": "La Paz",
                  "nameAr": "La Paz",
                  "nameFr": "La Paz"
            },
            {
                  "name": "La Unión ",
                  "nameAr": "La Unión ",
                  "nameFr": "La Unión "
            },
            {
                  "name": "Morazán",
                  "nameAr": "Morazán",
                  "nameFr": "Morazán"
            },
            {
                  "name": "San Miguel",
                  "nameAr": "San Miguel",
                  "nameFr": "San Miguel"
            },
            {
                  "name": "San Salvador",
                  "nameAr": "San Salvador",
                  "nameFr": "San Salvador"
            },
            {
                  "name": "San Vicente",
                  "nameAr": "San Vicente",
                  "nameFr": "San Vicente"
            },
            {
                  "name": "Santa Ana",
                  "nameAr": "Santa Ana",
                  "nameFr": "Santa Ana"
            },
            {
                  "name": "Sonsonate",
                  "nameAr": "Sonsonate",
                  "nameFr": "Sonsonate"
            },
            {
                  "name": "Usulután",
                  "nameAr": "Usulután",
                  "nameFr": "Usulután"
            }
      ]
  },
  {
    "code": "FK",
    "name": "Falkland Islands",
    "nameAr": "جزر فوكلاند",
    "nameFr": "Falkland Islands",
    "cities": [
            {
                  "name": "Aisén del General Carlos Ibañez del Campo",
                  "nameAr": "Aisén del General Carlos Ibañez del Campo",
                  "nameFr": "Aisén del General Carlos Ibañez del Campo"
            },
            {
                  "name": "Antofagasta",
                  "nameAr": "Antofagasta",
                  "nameFr": "Antofagasta"
            },
            {
                  "name": "Arica y Parinacota",
                  "nameAr": "Arica y Parinacota",
                  "nameFr": "Arica y Parinacota"
            },
            {
                  "name": "Atacama",
                  "nameAr": "Atacama",
                  "nameFr": "Atacama"
            },
            {
                  "name": "Biobío",
                  "nameAr": "Biobío",
                  "nameFr": "Biobío"
            },
            {
                  "name": "Coquimbo",
                  "nameAr": "Coquimbo",
                  "nameFr": "Coquimbo"
            },
            {
                  "name": "La Araucanía",
                  "nameAr": "La Araucanía",
                  "nameFr": "La Araucanía"
            },
            {
                  "name": "Libertador General Bernardo O'Higgins",
                  "nameAr": "Liberador General Bernardo O'Higgins",
                  "nameFr": "Libertador General Bernardo O'Higgins"
            },
            {
                  "name": "Los Lagos",
                  "nameAr": "Los Lagos",
                  "nameFr": "Los Lagos"
            },
            {
                  "name": "Los Ríos",
                  "nameAr": "Los Ríos",
                  "nameFr": "Los Ríos"
            },
            {
                  "name": "Magallanes y de la Antártica Chilena",
                  "nameAr": "Magallanes y de la Antártica Chilena",
                  "nameFr": "Magallanes y de la Antártica Chilena"
            },
            {
                  "name": "Maule",
                  "nameAr": "Maule",
                  "nameFr": "Maule"
            },
            {
                  "name": "Ñuble",
                  "nameAr": "Ñuble",
                  "nameFr": "Ñuble"
            },
            {
                  "name": "Región Metropolitana de Santiago",
                  "nameAr": "Región Metropolitana de Santiago",
                  "nameFr": "Región Metropolitana de Santiago"
            },
            {
                  "name": "Tarapacá",
                  "nameAr": "Tarapacá",
                  "nameFr": "Tarapacá"
            },
            {
                  "name": "Valparaíso",
                  "nameAr": "Valparaíso",
                  "nameFr": "Valparaíso"
            }
      ]
  },
  {
    "code": "GF",
    "name": "French Guiana",
    "nameAr": "غيانا الفرنسية",
    "nameFr": "French Guiana",
    "cities": []
  },
  {
    "code": "GL",
    "name": "Greenland",
    "nameAr": "غرينلاند",
    "nameFr": "Greenland",
    "cities": [
            {
                  "name": "Avannaata",
                  "nameAr": "Avannaata",
                  "nameFr": "Avannaata"
            },
            {
                  "name": "Kujalleq",
                  "nameAr": "Kujalleq",
                  "nameFr": "Kujalleq"
            },
            {
                  "name": "Qeqertalik",
                  "nameAr": "Qeqertalik",
                  "nameFr": "Qeqertalik"
            },
            {
                  "name": "Qeqqata",
                  "nameAr": "Qeqqata",
                  "nameFr": "Qeqqata"
            },
            {
                  "name": "Sermersooq",
                  "nameAr": "Sermersooq",
                  "nameFr": "Sermersooq"
            }
      ]
  },
  {
    "code": "GD",
    "name": "Grenada",
    "nameAr": "غرينادا",
    "nameFr": "Grenada",
    "cities": [
            {
                  "name": "Carriacou",
                  "nameAr": "Carriacou",
                  "nameFr": "Carriacou"
            },
            {
                  "name": "Saint Andrew",
                  "nameAr": "Saint Andrew",
                  "nameFr": "Saint Andrew"
            },
            {
                  "name": "Saint David",
                  "nameAr": "Saint David",
                  "nameFr": "Saint David"
            },
            {
                  "name": "Saint George",
                  "nameAr": "Saint George",
                  "nameFr": "Saint George"
            },
            {
                  "name": "Saint John",
                  "nameAr": "Saint John",
                  "nameFr": "Saint John"
            },
            {
                  "name": "Saint Mark",
                  "nameAr": "Saint Mark",
                  "nameFr": "Saint Mark"
            },
            {
                  "name": "Saint Patrick",
                  "nameAr": "Saint Patrick",
                  "nameFr": "Saint Patrick"
            }
      ]
  },
  {
    "code": "GP",
    "name": "Guadeloupe",
    "nameAr": "غوادلوب",
    "nameFr": "Guadeloupe",
    "cities": [
            {
                  "name": "Basse-Terre",
                  "nameAr": "Basse-Terre",
                  "nameFr": "Basse-Terre"
            },
            {
                  "name": "Pointe-à-Pitre",
                  "nameAr": "Pointe-à-Pitre",
                  "nameFr": "Pointe-à-Pitre"
            }
      ]
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "nameAr": "غواتيمالا",
    "nameFr": "Guatemala",
    "cities": [
            {
                  "name": "Alta Verapaz ",
                  "nameAr": "Alta Verapaz ",
                  "nameFr": "Alta Verapaz "
            },
            {
                  "name": "Baja Verapaz ",
                  "nameAr": "Baja Verapaz",
                  "nameFr": "Baja Verapaz "
            },
            {
                  "name": "Chimaltenango ",
                  "nameAr": "Chimaltenango",
                  "nameFr": "Chimaltenango "
            },
            {
                  "name": "Chiquimula ",
                  "nameAr": "Chiquimula",
                  "nameFr": "Chiquimula "
            },
            {
                  "name": "El Progreso ",
                  "nameAr": "El Progreso",
                  "nameFr": "El Progreso "
            },
            {
                  "name": "Escuintla ",
                  "nameAr": "Escuintla",
                  "nameFr": "Escuintla "
            },
            {
                  "name": "Guatemala ",
                  "nameAr": "Guatemala",
                  "nameFr": "Guatemala "
            },
            {
                  "name": "Huehuetenango ",
                  "nameAr": "Huehuetenango",
                  "nameFr": "Huehuetenango "
            },
            {
                  "name": "Izabal ",
                  "nameAr": "Izabal",
                  "nameFr": "Izabal "
            },
            {
                  "name": "Jalapa ",
                  "nameAr": "Jalapa",
                  "nameFr": "Jalapa "
            },
            {
                  "name": "Jutiapa ",
                  "nameAr": "Jutiapa",
                  "nameFr": "Jutiapa "
            },
            {
                  "name": "Petén ",
                  "nameAr": "Petén ",
                  "nameFr": "Petén "
            },
            {
                  "name": "Quetzaltenango ",
                  "nameAr": "Quetzaltenango",
                  "nameFr": "Quetzaltenango "
            },
            {
                  "name": "Quiché ",
                  "nameAr": "Quiché",
                  "nameFr": "Quiché "
            },
            {
                  "name": "Retalhuleu ",
                  "nameAr": "Retalhuleu",
                  "nameFr": "Retalhuleu "
            },
            {
                  "name": "Sacatepéquez ",
                  "nameAr": "Sacatepéquez",
                  "nameFr": "Sacatepéquez "
            },
            {
                  "name": "San Marcos ",
                  "nameAr": "San Marcos",
                  "nameFr": "San Marcos "
            },
            {
                  "name": "Santa Rosa ",
                  "nameAr": "Santa Rosa",
                  "nameFr": "Santa Rosa "
            },
            {
                  "name": "Sololá ",
                  "nameAr": "Sololá",
                  "nameFr": "Sololá "
            },
            {
                  "name": "Suchitepéquez ",
                  "nameAr": "Suchitepéquez",
                  "nameFr": "Suchitepéquez "
            },
            {
                  "name": "Totonicapán ",
                  "nameAr": "Totonicapán",
                  "nameFr": "Totonicapán "
            },
            {
                  "name": "Zacapa",
                  "nameAr": "Zacapa",
                  "nameFr": "Zacapa"
            }
      ]
  },
  {
    "code": "GY",
    "name": "Guyana",
    "nameAr": "غيانا",
    "nameFr": "Guyana",
    "cities": [
            {
                  "name": "Barima-Waini",
                  "nameAr": "Barima-Waini",
                  "nameFr": "Barima-Waini"
            },
            {
                  "name": "Cuyuni-Mazaruni",
                  "nameAr": "The Cunyi-Pieces",
                  "nameFr": "Cuyuni-Mazaruni"
            },
            {
                  "name": "Demerara-Mahaica",
                  "nameAr": "Demerara-Mahaica",
                  "nameFr": "Demerara-Mahaica"
            },
            {
                  "name": "East Berbice-Corentyne",
                  "nameAr": "East Berbice-Corentyne",
                  "nameFr": "East Berbice-Corentyne"
            },
            {
                  "name": "Essequibo Islands-West Demerara",
                  "nameAr": "Overcome Islands-West Demerara",
                  "nameFr": "Essequibo Islands-West Demerara"
            },
            {
                  "name": "Mahaica-Berbice",
                  "nameAr": "Mahaica-Berbice",
                  "nameFr": "Mahaica-Berbice"
            },
            {
                  "name": "Pomeroon-Supenaam",
                  "nameAr": "Pomerone superconame",
                  "nameFr": "Pomeroon-Supenaam"
            },
            {
                  "name": "Potaro-Siparuni",
                  "nameAr": "Potaro-saiparuni",
                  "nameFr": "Potaro-Siparuni"
            },
            {
                  "name": "Upper Demerara-Berbice",
                  "nameAr": "Upper Demerara-Berbice",
                  "nameFr": "Upper Demerara-Berbice"
            },
            {
                  "name": "Upper Takutu-Upper Essequibo",
                  "nameAr": "Upper Takutu-Upper Essequibo",
                  "nameFr": "Upper Takutu-Upper Essequibo"
            }
      ]
  },
  {
    "code": "HT",
    "name": "Haiti",
    "nameAr": "هايتي",
    "nameFr": "Haiti",
    "cities": [
            {
                  "name": "Artibonite",
                  "nameAr": "Artibonite",
                  "nameFr": "Artibonite"
            },
            {
                  "name": "Centre",
                  "nameAr": "Centre",
                  "nameFr": "Centre"
            },
            {
                  "name": "Grand'Anse",
                  "nameAr": "Grand'Anse",
                  "nameFr": "Grand'Anse"
            },
            {
                  "name": "Nippes",
                  "nameAr": "Nippes",
                  "nameFr": "Nippes"
            },
            {
                  "name": "Nord",
                  "nameAr": "Nord",
                  "nameFr": "Nord"
            },
            {
                  "name": "Nord-Est",
                  "nameAr": "Nord-Est",
                  "nameFr": "Nord-Est"
            },
            {
                  "name": "Nord-Ouest",
                  "nameAr": "Nord-Ouest",
                  "nameFr": "Nord-Ouest"
            },
            {
                  "name": "Ouest",
                  "nameAr": "Ouest",
                  "nameFr": "Ouest"
            },
            {
                  "name": "Sud",
                  "nameAr": "Soudoir",
                  "nameFr": "Sud"
            },
            {
                  "name": "Sud-Est",
                  "nameAr": "Sud-Est",
                  "nameFr": "Sud-Est"
            }
      ]
  },
  {
    "code": "HN",
    "name": "Honduras",
    "nameAr": "هندوراس",
    "nameFr": "Honduras",
    "cities": [
            {
                  "name": "Atlántida",
                  "nameAr": "Atlántida",
                  "nameFr": "Atlántida"
            },
            {
                  "name": "Bay Islands",
                  "nameAr": "Islas de la Bahía",
                  "nameFr": "Bay Islands"
            },
            {
                  "name": "Choluteca",
                  "nameAr": "Choluteca",
                  "nameFr": "Choluteca"
            },
            {
                  "name": "Colón",
                  "nameAr": "Colon",
                  "nameFr": "Colón"
            },
            {
                  "name": "Comayagua",
                  "nameAr": "Comayagua",
                  "nameFr": "Comayagua"
            },
            {
                  "name": "Copán",
                  "nameAr": "Copán",
                  "nameFr": "Copán"
            },
            {
                  "name": "Cortés",
                  "nameAr": "Cortés",
                  "nameFr": "Cortés"
            },
            {
                  "name": "El Paraíso",
                  "nameAr": "El Paraíso",
                  "nameFr": "El Paraíso"
            },
            {
                  "name": "Francisco Morazán",
                  "nameAr": "Francisco Morazán",
                  "nameFr": "Francisco Morazán"
            },
            {
                  "name": "Gracias a Dios",
                  "nameAr": "Gracias a Dios",
                  "nameFr": "Gracias a Dios"
            },
            {
                  "name": "Intibucá",
                  "nameAr": "Intibucá",
                  "nameFr": "Intibucá"
            },
            {
                  "name": "La Paz",
                  "nameAr": "La Paz",
                  "nameFr": "La Paz"
            },
            {
                  "name": "Lempira",
                  "nameAr": "Lempira",
                  "nameFr": "Lempira"
            },
            {
                  "name": "Ocotepeque",
                  "nameAr": "Ocotepeque",
                  "nameFr": "Ocotepeque"
            },
            {
                  "name": "Olancho",
                  "nameAr": "Olancho",
                  "nameFr": "Olancho"
            },
            {
                  "name": "Santa Bárbara",
                  "nameAr": "Santa Bárbara",
                  "nameFr": "Santa Bárbara"
            },
            {
                  "name": "Valle",
                  "nameAr": "Valle",
                  "nameFr": "Valle"
            },
            {
                  "name": "Yoro",
                  "nameAr": "Yoro",
                  "nameFr": "Yoro"
            }
      ]
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "nameAr": "جامايكا",
    "nameFr": "Jamaica",
    "cities": [
            {
                  "name": "Clarendon",
                  "nameAr": "Clarendon",
                  "nameFr": "Clarendon"
            },
            {
                  "name": "Hanover",
                  "nameAr": "Hanover",
                  "nameFr": "Hanover"
            },
            {
                  "name": "Kingston",
                  "nameAr": "Kingston",
                  "nameFr": "Kingston"
            },
            {
                  "name": "Manchester",
                  "nameAr": "Manchester",
                  "nameFr": "Manchester"
            },
            {
                  "name": "Portland",
                  "nameAr": "Portland",
                  "nameFr": "Portland"
            },
            {
                  "name": "Saint Andrew",
                  "nameAr": "Saint Andrew",
                  "nameFr": "Saint Andrew"
            },
            {
                  "name": "Saint Ann",
                  "nameAr": "Saint Ann",
                  "nameFr": "Saint Ann"
            },
            {
                  "name": "Saint Catherine",
                  "nameAr": "Saint Catherine",
                  "nameFr": "Saint Catherine"
            },
            {
                  "name": "Saint Elizabeth",
                  "nameAr": "Saint Elizabeth",
                  "nameFr": "Saint Elizabeth"
            },
            {
                  "name": "Saint James",
                  "nameAr": "Saint James",
                  "nameFr": "Saint James"
            },
            {
                  "name": "Saint Mary",
                  "nameAr": "Saint Mary",
                  "nameFr": "Saint Mary"
            },
            {
                  "name": "Saint Thomas",
                  "nameAr": "Saint Thomas",
                  "nameFr": "Saint Thomas"
            },
            {
                  "name": "Trelawny",
                  "nameAr": "Trelawny",
                  "nameFr": "Trelawny"
            },
            {
                  "name": "Westmoreland",
                  "nameAr": "Westmoreland",
                  "nameFr": "Westmoreland"
            }
      ]
  },
  {
    "code": "MQ",
    "name": "Martinique",
    "nameAr": "مارتينيك",
    "nameFr": "Martinique",
    "cities": [
            {
                  "name": "Fort-de-France",
                  "nameAr": "Fort-de-France",
                  "nameFr": "Fort-de-France"
            },
            {
                  "name": "La Trinité",
                  "nameAr": "La Trinité",
                  "nameFr": "La Trinité"
            },
            {
                  "name": "Le Marin",
                  "nameAr": "Le Marin",
                  "nameFr": "Le Marin"
            },
            {
                  "name": "Saint-Pierre",
                  "nameAr": "Saint-Pierre",
                  "nameFr": "Saint-Pierre"
            }
      ]
  },
  {
    "code": "MX",
    "name": "Mexico",
    "nameAr": "المكسيك",
    "nameFr": "Mexico",
    "cities": [
            {
                  "name": "Aguascalientes",
                  "nameAr": "Aguascalientes",
                  "nameFr": "Aguascalientes"
            },
            {
                  "name": "Baja California",
                  "nameAr": "Baja California",
                  "nameFr": "Baja California"
            },
            {
                  "name": "Baja California Sur",
                  "nameAr": "Baja California Sur",
                  "nameFr": "Baja California Sur"
            },
            {
                  "name": "Campeche",
                  "nameAr": "Campeche",
                  "nameFr": "Campeche"
            },
            {
                  "name": "Chiapas",
                  "nameAr": "Chiapas",
                  "nameFr": "Chiapas"
            },
            {
                  "name": "Chihuahua",
                  "nameAr": "Chihuahua",
                  "nameFr": "Chihuahua"
            },
            {
                  "name": "Ciudad de México",
                  "nameAr": "Ciudad de México",
                  "nameFr": "Ciudad de México"
            },
            {
                  "name": "Coahuila de Zaragoza",
                  "nameAr": "Coahuila de Zaragoza",
                  "nameFr": "Coahuila de Zaragoza"
            },
            {
                  "name": "Colima",
                  "nameAr": "Colima",
                  "nameFr": "Colima"
            },
            {
                  "name": "Durango",
                  "nameAr": "Durango",
                  "nameFr": "Durango"
            },
            {
                  "name": "Estado de México",
                  "nameAr": "Estado de México",
                  "nameFr": "Estado de México"
            },
            {
                  "name": "Guanajuato",
                  "nameAr": "Guanajuato",
                  "nameFr": "Guanajuato"
            },
            {
                  "name": "Guerrero",
                  "nameAr": "Guerrero",
                  "nameFr": "Guerrero"
            },
            {
                  "name": "Hidalgo",
                  "nameAr": "Hidalgo",
                  "nameFr": "Hidalgo"
            },
            {
                  "name": "Jalisco",
                  "nameAr": "Jalisco",
                  "nameFr": "Jalisco"
            },
            {
                  "name": "Michoacán de Ocampo",
                  "nameAr": "Michoacán de Ocampo",
                  "nameFr": "Michoacán de Ocampo"
            },
            {
                  "name": "Morelos",
                  "nameAr": "Morelos",
                  "nameFr": "Morelos"
            },
            {
                  "name": "Nayarit",
                  "nameAr": "Nayarit",
                  "nameFr": "Nayarit"
            },
            {
                  "name": "Nuevo León",
                  "nameAr": "Nuevo León",
                  "nameFr": "Nuevo León"
            },
            {
                  "name": "Oaxaca",
                  "nameAr": "Oaxaca",
                  "nameFr": "Oaxaca"
            },
            {
                  "name": "Puebla",
                  "nameAr": "Puebla",
                  "nameFr": "Puebla"
            },
            {
                  "name": "Querétaro",
                  "nameAr": "Querétaro",
                  "nameFr": "Querétaro"
            },
            {
                  "name": "Quintana Roo",
                  "nameAr": "Quintana Roo",
                  "nameFr": "Quintana Roo"
            },
            {
                  "name": "San Luis Potosí",
                  "nameAr": "San Luis Potosí",
                  "nameFr": "San Luis Potosí"
            },
            {
                  "name": "Sinaloa",
                  "nameAr": "Sinaloa",
                  "nameFr": "Sinaloa"
            },
            {
                  "name": "Sonora",
                  "nameAr": "Sonora",
                  "nameFr": "Sonora"
            },
            {
                  "name": "Tabasco",
                  "nameAr": "Tabasco",
                  "nameFr": "Tabasco"
            },
            {
                  "name": "Tamaulipas",
                  "nameAr": "Tamaulipas",
                  "nameFr": "Tamaulipas"
            },
            {
                  "name": "Tlaxcala",
                  "nameAr": "Tlaxcala",
                  "nameFr": "Tlaxcala"
            },
            {
                  "name": "Veracruz de Ignacio de la Llave",
                  "nameAr": "Veracruz de Ignacio de la Llave",
                  "nameFr": "Veracruz de Ignacio de la Llave"
            },
            {
                  "name": "Yucatán",
                  "nameAr": "Yucatán",
                  "nameFr": "Yucatán"
            },
            {
                  "name": "Zacatecas",
                  "nameAr": "Zacatecas",
                  "nameFr": "Zacatecas"
            }
      ]
  },
  {
    "code": "MS",
    "name": "Montserrat",
    "nameAr": "مونتسيرات",
    "nameFr": "Montserrat",
    "cities": [
            {
                  "name": "Saint Anthony",
                  "nameAr": "Saint Anthony",
                  "nameFr": "Saint Anthony"
            },
            {
                  "name": "Saint Georges",
                  "nameAr": "Saint Georges",
                  "nameFr": "Saint Georges"
            },
            {
                  "name": "Saint Peter",
                  "nameAr": "Saint Peter",
                  "nameFr": "Saint Peter"
            }
      ]
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "nameAr": "نيكاراغوا",
    "nameFr": "Nicaragua",
    "cities": [
            {
                  "name": "Boaco",
                  "nameAr": "Reno",
                  "nameFr": "Boaco"
            },
            {
                  "name": "Carazo",
                  "nameAr": "Carazo",
                  "nameFr": "Carazo"
            },
            {
                  "name": "Chinandega",
                  "nameAr": "Chinandega",
                  "nameFr": "Chinandega"
            },
            {
                  "name": "Chontales",
                  "nameAr": "Chontales",
                  "nameFr": "Chontales"
            },
            {
                  "name": "Estelí",
                  "nameAr": "Estelí",
                  "nameFr": "Estelí"
            },
            {
                  "name": "Granada",
                  "nameAr": "Granada",
                  "nameFr": "Granada"
            },
            {
                  "name": "Jinotega",
                  "nameAr": "Jinotega",
                  "nameFr": "Jinotega"
            },
            {
                  "name": "León",
                  "nameAr": "León",
                  "nameFr": "León"
            },
            {
                  "name": "Madriz",
                  "nameAr": "Madriz",
                  "nameFr": "Madriz"
            },
            {
                  "name": "Managua",
                  "nameAr": "Gerencia",
                  "nameFr": "Managua"
            },
            {
                  "name": "Masaya",
                  "nameAr": "Es divertido",
                  "nameFr": "Masaya"
            },
            {
                  "name": "Matagalpa",
                  "nameAr": "Matagalpa",
                  "nameFr": "Matagalpa"
            },
            {
                  "name": "North Caribbean Coast",
                  "nameAr": "Costa del Caribe del Norte",
                  "nameFr": "North Caribbean Coast"
            },
            {
                  "name": "Nueva Segovia",
                  "nameAr": "Nueva Segovia",
                  "nameFr": "Nueva Segovia"
            },
            {
                  "name": "Río San Juan",
                  "nameAr": "Río San Juan",
                  "nameFr": "Río San Juan"
            },
            {
                  "name": "Rivas",
                  "nameAr": "Rivas",
                  "nameFr": "Rivas"
            },
            {
                  "name": "South Caribbean Coast",
                  "nameAr": "Costa del Caribe del Sur",
                  "nameFr": "South Caribbean Coast"
            }
      ]
  },
  {
    "code": "PA",
    "name": "Panama",
    "nameAr": "بنما",
    "nameFr": "Panama",
    "cities": [
            {
                  "name": "Bocas del Toro",
                  "nameAr": "Bocas del Toro",
                  "nameFr": "Bocas del Toro"
            },
            {
                  "name": "Chiriquí Province",
                  "nameAr": "Chiriquí Province",
                  "nameFr": "Chiriquí Province"
            },
            {
                  "name": "Coclé",
                  "nameAr": "Coclé",
                  "nameFr": "Coclé"
            },
            {
                  "name": "Colón",
                  "nameAr": "Colon",
                  "nameFr": "Colón"
            },
            {
                  "name": "Darién",
                  "nameAr": "Darién",
                  "nameFr": "Darién"
            },
            {
                  "name": "Emberá-Wounaan Comarca",
                  "nameAr": "Emberá-Wounaan Comarca",
                  "nameFr": "Emberá-Wounaan Comarca"
            },
            {
                  "name": "Guna",
                  "nameAr": "Guna",
                  "nameFr": "Guna"
            },
            {
                  "name": "Herrera",
                  "nameAr": "Herrera",
                  "nameFr": "Herrera"
            },
            {
                  "name": "Los Santos",
                  "nameAr": "Los Santos",
                  "nameFr": "Los Santos"
            },
            {
                  "name": "Ngöbe-Buglé Comarca",
                  "nameAr": "Ngöbe-Buglé Comarca",
                  "nameFr": "Ngöbe-Buglé Comarca"
            },
            {
                  "name": "Panamá",
                  "nameAr": "Panamá",
                  "nameFr": "Panamá"
            },
            {
                  "name": "Panamá Oeste",
                  "nameAr": "Panamá Oeste",
                  "nameFr": "Panamá Oeste"
            },
            {
                  "name": "Veraguas",
                  "nameAr": "Veraguas",
                  "nameFr": "Veraguas"
            }
      ]
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "nameAr": "باراغواي",
    "nameFr": "Paraguay",
    "cities": [
            {
                  "name": "Alto Paraguay",
                  "nameAr": "Alto Paraguay",
                  "nameFr": "Alto Paraguay"
            },
            {
                  "name": "Alto Paraná",
                  "nameAr": "Alto paraná",
                  "nameFr": "Alto Paraná"
            },
            {
                  "name": "Amambay",
                  "nameAr": "Amambay",
                  "nameFr": "Amambay"
            },
            {
                  "name": "Asuncion",
                  "nameAr": "Asunción",
                  "nameFr": "Asuncion"
            },
            {
                  "name": "Boquerón",
                  "nameAr": "Boquerón",
                  "nameFr": "Boquerón"
            },
            {
                  "name": "Caaguazú",
                  "nameAr": "Caaguazú",
                  "nameFr": "Caaguazú"
            },
            {
                  "name": "Caazapá",
                  "nameAr": "Caazapá",
                  "nameFr": "Caazapá"
            },
            {
                  "name": "Canindeyú",
                  "nameAr": "Canindeyú",
                  "nameFr": "Canindeyú"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Concepción",
                  "nameAr": "Concepción",
                  "nameFr": "Concepción"
            },
            {
                  "name": "Cordillera",
                  "nameAr": "Cordillera",
                  "nameFr": "Cordillera"
            },
            {
                  "name": "Guairá",
                  "nameAr": "Guairá",
                  "nameFr": "Guairá"
            },
            {
                  "name": "Itapúa",
                  "nameAr": "Itapúa",
                  "nameFr": "Itapúa"
            },
            {
                  "name": "Misiones",
                  "nameAr": "Misiones",
                  "nameFr": "Misiones"
            },
            {
                  "name": "Ñeembucú",
                  "nameAr": "Ñeembucú",
                  "nameFr": "Ñeembucú"
            },
            {
                  "name": "Paraguarí",
                  "nameAr": "Paraguarí",
                  "nameFr": "Paraguarí"
            },
            {
                  "name": "Presidente Hayes",
                  "nameAr": "Presidente Hayes",
                  "nameFr": "Presidente Hayes"
            },
            {
                  "name": "San Pedro",
                  "nameAr": "San Pedro",
                  "nameFr": "San Pedro"
            }
      ]
  },
  {
    "code": "PE",
    "name": "Peru",
    "nameAr": "بيرو",
    "nameFr": "Peru",
    "cities": [
            {
                  "name": "Amazonas",
                  "nameAr": "Amazonas",
                  "nameFr": "Amazonas"
            },
            {
                  "name": "Áncash",
                  "nameAr": "Áncash",
                  "nameFr": "Áncash"
            },
            {
                  "name": "Apurímac",
                  "nameAr": "Apurímac",
                  "nameFr": "Apurímac"
            },
            {
                  "name": "Arequipa",
                  "nameAr": "Arequipa",
                  "nameFr": "Arequipa"
            },
            {
                  "name": "Ayacucho",
                  "nameAr": "Ayacucho",
                  "nameFr": "Ayacucho"
            },
            {
                  "name": "Cajamarca",
                  "nameAr": "Cajamarca",
                  "nameFr": "Cajamarca"
            },
            {
                  "name": "Callao",
                  "nameAr": "Callao",
                  "nameFr": "Callao"
            },
            {
                  "name": "Cusco",
                  "nameAr": "Cúsa",
                  "nameFr": "Cusco"
            },
            {
                  "name": "Huancavelica",
                  "nameAr": "Huancavelica",
                  "nameFr": "Huancavelica"
            },
            {
                  "name": "Huanuco",
                  "nameAr": "Huanuco",
                  "nameFr": "Huanuco"
            },
            {
                  "name": "Ica",
                  "nameAr": "ICA",
                  "nameFr": "Ica"
            },
            {
                  "name": "Junín",
                  "nameAr": "Junín",
                  "nameFr": "Junín"
            },
            {
                  "name": "La Libertad",
                  "nameAr": "La Libertad",
                  "nameFr": "La Libertad"
            },
            {
                  "name": "Lambayeque",
                  "nameAr": "Lambayeque",
                  "nameFr": "Lambayeque"
            },
            {
                  "name": "Lima",
                  "nameAr": "Lima",
                  "nameFr": "Lima"
            },
            {
                  "name": "Loreto",
                  "nameAr": "Loreto",
                  "nameFr": "Loreto"
            },
            {
                  "name": "Madre de Dios",
                  "nameAr": "Madre de Dios",
                  "nameFr": "Madre de Dios"
            },
            {
                  "name": "Moquegua",
                  "nameAr": "Moquegua",
                  "nameFr": "Moquegua"
            },
            {
                  "name": "Pasco",
                  "nameAr": "Pasto",
                  "nameFr": "Pasco"
            },
            {
                  "name": "Piura",
                  "nameAr": "Piura",
                  "nameFr": "Piura"
            },
            {
                  "name": "Puno",
                  "nameAr": "Mucho",
                  "nameFr": "Puno"
            },
            {
                  "name": "San Martín",
                  "nameAr": "San Martín",
                  "nameFr": "San Martín"
            },
            {
                  "name": "Tacna",
                  "nameAr": "Tacna",
                  "nameFr": "Tacna"
            },
            {
                  "name": "Tumbes",
                  "nameAr": "Tumbes",
                  "nameFr": "Tumbes"
            },
            {
                  "name": "Ucayali",
                  "nameAr": "Ucayali",
                  "nameFr": "Ucayali"
            }
      ]
  },
  {
    "code": "PR",
    "name": "Puerto Rico",
    "nameAr": "بورتوريكو",
    "nameFr": "Puerto Rico",
    "cities": [
      {
        "name": "Adjuntas",
        "nameAr": "",
        "nameFr": "Adjuntas"
      },
      {
        "name": "Aguada",
        "nameAr": "",
        "nameFr": "Aguada"
      },
      {
        "name": "Aguadilla",
        "nameAr": "",
        "nameFr": "Aguadilla"
      },
      {
        "name": "Aguas Buenas",
        "nameAr": "",
        "nameFr": "Aguas Buenas"
      },
      {
        "name": "Aibonito",
        "nameAr": "",
        "nameFr": "Aibonito"
      },
      {
        "name": "Añasco",
        "nameAr": "",
        "nameFr": "Añasco"
      },
      {
        "name": "Arecibo",
        "nameAr": "",
        "nameFr": "Arecibo"
      },
      {
        "name": "Arecibo",
        "nameAr": "",
        "nameFr": "Arecibo"
      },
      {
        "name": "Arroyo",
        "nameAr": "",
        "nameFr": "Arroyo"
      },
      {
        "name": "Barceloneta",
        "nameAr": "",
        "nameFr": "Barceloneta"
      },
      {
        "name": "Barranquitas",
        "nameAr": "",
        "nameFr": "Barranquitas"
      },
      {
        "name": "Bayamon",
        "nameAr": "",
        "nameFr": "Bayamon"
      },
      {
        "name": "Bayamón",
        "nameAr": "",
        "nameFr": "Bayamón"
      },
      {
        "name": "Cabo Rojo",
        "nameAr": "",
        "nameFr": "Cabo Rojo"
      },
      {
        "name": "Caguas",
        "nameAr": "",
        "nameFr": "Caguas"
      },
      {
        "name": "Caguas",
        "nameAr": "",
        "nameFr": "Caguas"
      },
      {
        "name": "Camuy",
        "nameAr": "",
        "nameFr": "Camuy"
      },
      {
        "name": "Canóvanas",
        "nameAr": "",
        "nameFr": "Canóvanas"
      },
      {
        "name": "Carolina",
        "nameAr": "",
        "nameFr": "Carolina"
      },
      {
        "name": "Carolina",
        "nameAr": "",
        "nameFr": "Carolina"
      },
      {
        "name": "Cataño",
        "nameAr": "",
        "nameFr": "Cataño"
      },
      {
        "name": "Cayey",
        "nameAr": "",
        "nameFr": "Cayey"
      },
      {
        "name": "Ceiba",
        "nameAr": "",
        "nameFr": "Ceiba"
      },
      {
        "name": "Ciales",
        "nameAr": "",
        "nameFr": "Ciales"
      },
      {
        "name": "Cidra",
        "nameAr": "",
        "nameFr": "Cidra"
      },
      {
        "name": "Coamo",
        "nameAr": "",
        "nameFr": "Coamo"
      },
      {
        "name": "Comerío",
        "nameAr": "",
        "nameFr": "Comerío"
      },
      {
        "name": "Corozal",
        "nameAr": "",
        "nameFr": "Corozal"
      },
      {
        "name": "Culebra",
        "nameAr": "",
        "nameFr": "Culebra"
      },
      {
        "name": "Dorado",
        "nameAr": "",
        "nameFr": "Dorado"
      },
      {
        "name": "Fajardo",
        "nameAr": "",
        "nameFr": "Fajardo"
      },
      {
        "name": "Florida",
        "nameAr": "",
        "nameFr": "Florida"
      },
      {
        "name": "Guánica",
        "nameAr": "",
        "nameFr": "Guánica"
      },
      {
        "name": "Guayama",
        "nameAr": "",
        "nameFr": "Guayama"
      },
      {
        "name": "Guayanilla",
        "nameAr": "",
        "nameFr": "Guayanilla"
      },
      {
        "name": "Guaynabo",
        "nameAr": "",
        "nameFr": "Guaynabo"
      },
      {
        "name": "Guaynabo",
        "nameAr": "",
        "nameFr": "Guaynabo"
      },
      {
        "name": "Gurabo",
        "nameAr": "",
        "nameFr": "Gurabo"
      },
      {
        "name": "Hatillo",
        "nameAr": "",
        "nameFr": "Hatillo"
      },
      {
        "name": "Hormigueros",
        "nameAr": "",
        "nameFr": "Hormigueros"
      },
      {
        "name": "Humacao",
        "nameAr": "",
        "nameFr": "Humacao"
      },
      {
        "name": "Isabela",
        "nameAr": "",
        "nameFr": "Isabela"
      },
      {
        "name": "Jayuya",
        "nameAr": "",
        "nameFr": "Jayuya"
      },
      {
        "name": "Juana Díaz",
        "nameAr": "",
        "nameFr": "Juana Díaz"
      },
      {
        "name": "Juncos",
        "nameAr": "",
        "nameFr": "Juncos"
      },
      {
        "name": "Lajas",
        "nameAr": "",
        "nameFr": "Lajas"
      },
      {
        "name": "Lares",
        "nameAr": "",
        "nameFr": "Lares"
      },
      {
        "name": "Las Marías",
        "nameAr": "",
        "nameFr": "Las Marías"
      },
      {
        "name": "Las Piedras",
        "nameAr": "",
        "nameFr": "Las Piedras"
      },
      {
        "name": "Loíza",
        "nameAr": "",
        "nameFr": "Loíza"
      },
      {
        "name": "Luquillo",
        "nameAr": "",
        "nameFr": "Luquillo"
      },
      {
        "name": "Manatí",
        "nameAr": "",
        "nameFr": "Manatí"
      },
      {
        "name": "Maricao",
        "nameAr": "",
        "nameFr": "Maricao"
      },
      {
        "name": "Maunabo",
        "nameAr": "",
        "nameFr": "Maunabo"
      },
      {
        "name": "Mayagüez",
        "nameAr": "",
        "nameFr": "Mayagüez"
      },
      {
        "name": "Mayagüez",
        "nameAr": "",
        "nameFr": "Mayagüez"
      },
      {
        "name": "Moca",
        "nameAr": "",
        "nameFr": "Moca"
      },
      {
        "name": "Morovis",
        "nameAr": "",
        "nameFr": "Morovis"
      },
      {
        "name": "Naguabo",
        "nameAr": "",
        "nameFr": "Naguabo"
      },
      {
        "name": "Naranjito",
        "nameAr": "",
        "nameFr": "Naranjito"
      },
      {
        "name": "Orocovis",
        "nameAr": "",
        "nameFr": "Orocovis"
      },
      {
        "name": "Patillas",
        "nameAr": "",
        "nameFr": "Patillas"
      },
      {
        "name": "Peñuelas",
        "nameAr": "",
        "nameFr": "Peñuelas"
      },
      {
        "name": "Ponce",
        "nameAr": "",
        "nameFr": "Ponce"
      },
      {
        "name": "Ponce",
        "nameAr": "",
        "nameFr": "Ponce"
      },
      {
        "name": "Quebradillas",
        "nameAr": "",
        "nameFr": "Quebradillas"
      },
      {
        "name": "Rincón",
        "nameAr": "",
        "nameFr": "Rincón"
      },
      {
        "name": "Río Grande",
        "nameAr": "",
        "nameFr": "Río Grande"
      },
      {
        "name": "Sabana Grande",
        "nameAr": "",
        "nameFr": "Sabana Grande"
      },
      {
        "name": "Salinas",
        "nameAr": "",
        "nameFr": "Salinas"
      },
      {
        "name": "San Germán",
        "nameAr": "",
        "nameFr": "San Germán"
      },
      {
        "name": "San Juan",
        "nameAr": "",
        "nameFr": "San Juan"
      },
      {
        "name": "San Juan",
        "nameAr": "",
        "nameFr": "San Juan"
      },
      {
        "name": "San Lorenzo",
        "nameAr": "",
        "nameFr": "San Lorenzo"
      },
      {
        "name": "San Sebastián",
        "nameAr": "",
        "nameFr": "San Sebastián"
      },
      {
        "name": "Santa Isabel",
        "nameAr": "",
        "nameFr": "Santa Isabel"
      },
      {
        "name": "Toa Alta",
        "nameAr": "",
        "nameFr": "Toa Alta"
      },
      {
        "name": "Toa Baja",
        "nameAr": "",
        "nameFr": "Toa Baja"
      },
      {
        "name": "Toa Baja",
        "nameAr": "",
        "nameFr": "Toa Baja"
      },
      {
        "name": "Trujillo Alto",
        "nameAr": "",
        "nameFr": "Trujillo Alto"
      },
      {
        "name": "Trujillo Alto",
        "nameAr": "",
        "nameFr": "Trujillo Alto"
      },
      {
        "name": "Utuado",
        "nameAr": "",
        "nameFr": "Utuado"
      },
      {
        "name": "Vega Alta",
        "nameAr": "",
        "nameFr": "Vega Alta"
      },
      {
        "name": "Vega Baja",
        "nameAr": "",
        "nameFr": "Vega Baja"
      },
      {
        "name": "Vieques",
        "nameAr": "",
        "nameFr": "Vieques"
      },
      {
        "name": "Villalba",
        "nameAr": "",
        "nameFr": "Villalba"
      },
      {
        "name": "Yabucoa",
        "nameAr": "",
        "nameFr": "Yabucoa"
      },
      {
        "name": "Yauco",
        "nameAr": "",
        "nameFr": "Yauco"
      }
    ]
  },
  {
    "code": "KN",
    "name": "Saint Kitts and Nevis",
    "nameAr": "سانت كيتس ونيفيس",
    "nameFr": "Saint Kitts and Nevis",
    "cities": [
            {
                  "name": "Christ Church Nichola Town",
                  "nameAr": "Christ Church Nichola Town",
                  "nameFr": "Christ Church Nichola Town"
            },
            {
                  "name": "Nevis",
                  "nameAr": "Nevis",
                  "nameFr": "Nevis"
            },
            {
                  "name": "Saint Anne Sandy Point",
                  "nameAr": "Saint Anne Sandy Point",
                  "nameFr": "Saint Anne Sandy Point"
            },
            {
                  "name": "Saint George Basseterre",
                  "nameAr": "Saint George Basseterre",
                  "nameFr": "Saint George Basseterre"
            },
            {
                  "name": "Saint George Gingerland",
                  "nameAr": "Saint George Gingerland",
                  "nameFr": "Saint George Gingerland"
            },
            {
                  "name": "Saint James Windward",
                  "nameAr": "Saint James Windward",
                  "nameFr": "Saint James Windward"
            },
            {
                  "name": "Saint John Capisterre",
                  "nameAr": "Saint John Capisterre",
                  "nameFr": "Saint John Capisterre"
            },
            {
                  "name": "Saint John Figtree",
                  "nameAr": "Saint John Figtree",
                  "nameFr": "Saint John Figtree"
            },
            {
                  "name": "Saint Kitts",
                  "nameAr": "Saint Kitts",
                  "nameFr": "Saint Kitts"
            },
            {
                  "name": "Saint Mary Cayon",
                  "nameAr": "Saint Mary Cayon",
                  "nameFr": "Saint Mary Cayon"
            },
            {
                  "name": "Saint Paul Capisterre",
                  "nameAr": "Saint Paul Capisterre",
                  "nameFr": "Saint Paul Capisterre"
            },
            {
                  "name": "Saint Paul Charlestown",
                  "nameAr": "Saint Paul Charlestown",
                  "nameFr": "Saint Paul Charlestown"
            },
            {
                  "name": "Saint Peter Basseterre",
                  "nameAr": "Saint Peter Basseterre",
                  "nameFr": "Saint Peter Basseterre"
            },
            {
                  "name": "Saint Thomas Lowland",
                  "nameAr": "Saint Thomas Lowland",
                  "nameFr": "Saint Thomas Lowland"
            },
            {
                  "name": "Saint Thomas Middle Island",
                  "nameAr": "Saint Thomas Middle Island",
                  "nameFr": "Saint Thomas Middle Island"
            },
            {
                  "name": "Trinity Palmetto Point",
                  "nameAr": "Trinity Palmetto Point",
                  "nameFr": "Trinity Palmetto Point"
            }
      ]
  },
  {
    "code": "LC",
    "name": "Saint Lucia",
    "nameAr": "سانت لوسيا",
    "nameFr": "Saint Lucia",
    "cities": [
            {
                  "name": "Anse la Raye",
                  "nameAr": "Anse la Raye",
                  "nameFr": "Anse la Raye"
            },
            {
                  "name": "Canaries",
                  "nameAr": "Canaries",
                  "nameFr": "Canaries"
            },
            {
                  "name": "Castries",
                  "nameAr": "Castries",
                  "nameFr": "Castries"
            },
            {
                  "name": "Choiseul",
                  "nameAr": "Choiseul",
                  "nameFr": "Choiseul"
            },
            {
                  "name": "Dauphin",
                  "nameAr": "Dauphin",
                  "nameFr": "Dauphin"
            },
            {
                  "name": "Dennery",
                  "nameAr": "Dennery",
                  "nameFr": "Dennery"
            },
            {
                  "name": "Gros Islet",
                  "nameAr": "Gros islet",
                  "nameFr": "Gros Islet"
            },
            {
                  "name": "Laborie",
                  "nameAr": "Labor",
                  "nameFr": "Laborie"
            },
            {
                  "name": "Micoud",
                  "nameAr": "Micoud",
                  "nameFr": "Micoud"
            },
            {
                  "name": "Praslin",
                  "nameAr": "Praslin",
                  "nameFr": "Praslin"
            },
            {
                  "name": "Soufrière",
                  "nameAr": "Sulfur",
                  "nameFr": "Soufrière"
            },
            {
                  "name": "Vieux Fort",
                  "nameAr": "Vieux Fort",
                  "nameFr": "Vieux Fort"
            }
      ]
  },
  {
    "code": "PM",
    "name": "Saint Pierre and Miquelon",
    "nameAr": "سان بيير وميكلون",
    "nameFr": "Saint Pierre and Miquelon",
    "cities": []
  },
  {
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
    "nameAr": "سانت فنسنت والغرينادين",
    "nameFr": "Saint Vincent and the Grenadines",
    "cities": [
            {
                  "name": "Charlotte",
                  "nameAr": "Charlotte",
                  "nameFr": "Charlotte"
            },
            {
                  "name": "Grenadines",
                  "nameAr": "Grenadines",
                  "nameFr": "Grenadines"
            },
            {
                  "name": "Saint Andrew",
                  "nameAr": "Saint Andrew",
                  "nameFr": "Saint Andrew"
            },
            {
                  "name": "Saint David",
                  "nameAr": "Saint David",
                  "nameFr": "Saint David"
            },
            {
                  "name": "Saint George",
                  "nameAr": "Saint George",
                  "nameFr": "Saint George"
            },
            {
                  "name": "Saint Patrick",
                  "nameAr": "Saint Patrick",
                  "nameFr": "Saint Patrick"
            }
      ]
  },
  {
    "code": "BL",
    "name": "Saint-Barthelemy",
    "nameAr": "سان بارتيلمي",
    "nameFr": "Saint-Barthelemy",
    "cities": []
  },
  {
    "code": "MF",
    "name": "Saint-Martin (French part)",
    "nameAr": "سان مارتن",
    "nameFr": "Saint-Martin (French part)",
    "cities": []
  },
  {
    "code": "SX",
    "name": "Sint Maarten (Dutch part)",
    "nameAr": "سانت مارتن",
    "nameFr": "Sint Maarten (Dutch part)",
    "cities": []
  },
  {
    "code": "GS",
    "name": "South Georgia",
    "nameAr": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
    "nameFr": "South Georgia",
    "cities": []
  },
  {
    "code": "SR",
    "name": "Suriname",
    "nameAr": "سورينام",
    "nameFr": "Suriname",
    "cities": [
            {
                  "name": "Brokopondo",
                  "nameAr": "Brocopondo",
                  "nameFr": "Brokopondo"
            },
            {
                  "name": "Commewijne",
                  "nameAr": "Commewijne",
                  "nameFr": "Commewijne"
            },
            {
                  "name": "Coronie",
                  "nameAr": "Coronie",
                  "nameFr": "Coronie"
            },
            {
                  "name": "Marowijne",
                  "nameAr": "Marowijne",
                  "nameFr": "Marowijne"
            },
            {
                  "name": "Nickerie",
                  "nameAr": "Nickerie",
                  "nameFr": "Nickerie"
            },
            {
                  "name": "Para",
                  "nameAr": "Naar",
                  "nameFr": "Para"
            },
            {
                  "name": "Paramaribo",
                  "nameAr": "Paramaribo",
                  "nameFr": "Paramaribo"
            },
            {
                  "name": "Saramacca",
                  "nameAr": "Saramacca",
                  "nameFr": "Saramacca"
            },
            {
                  "name": "Sipaliwini",
                  "nameAr": "Sipaliwini",
                  "nameFr": "Sipaliwini"
            },
            {
                  "name": "Wanica",
                  "nameAr": "Wanica",
                  "nameFr": "Wanica"
            }
      ]
  },
  {
    "code": "BS",
    "name": "The Bahamas",
    "nameAr": "الباهاما",
    "nameFr": "The Bahamas",
    "cities": [
      {
        "name": "Acklins and Crooked Islands",
        "nameAr": "Acklins and Crooked Islands",
        "nameFr": "Acklins et les îles Crooked"
      },
      {
        "name": "Mayaguana",
        "nameAr": "ماياجيوانا",
        "nameFr": "Mayaguana"
      },
      {
        "name": "Long Island",
        "nameAr": "جزيرة طويلة",
        "nameFr": "Long Island"
      },
      {
        "name": "New Providence",
        "nameAr": "بروفيدانس الجديدة",
        "nameFr": "New Providence"
      },
      {
        "name": "Exuma",
        "nameAr": "اكسوما",
        "nameFr": "Exuma"
      },
      {
        "name": "Bimini",
        "nameAr": "بيميني",
        "nameFr": "Bimini"
      },
      {
        "name": "San Salvador and Rum Cay",
        "nameAr": "سان سلفادور وروم كاي",
        "nameFr": "San Salvador et Rum Cay"
      },
      {
        "name": "Fresh Creek",
        "nameAr": "فريش كريك",
        "nameFr": "Fresh Creek"
      },
      {
        "name": "Cat Island",
        "nameAr": "جزيرة القط",
        "nameFr": "Île de chat"
      },
      {
        "name": "Nichollstown and Berry Islands",
        "nameAr": "Nichollstown و جزر بيري",
        "nameFr": "Nichollstown et les îles Berry"
      },
      {
        "name": "Kemps Bay",
        "nameAr": "كيمبس باي",
        "nameFr": "Kemps Bay"
      },
      {
        "name": "Freeport",
        "nameAr": "ميناء حر",
        "nameFr": "Freeport"
      },
      {
        "name": "Rock Sound",
        "nameAr": "صوت صخري",
        "nameFr": "Son rock"
      },
      {
        "name": "Harbour Island",
        "nameAr": "جزيرة الميناء",
        "nameFr": "Harbour Island"
      },
      {
        "name": "High Rock",
        "nameAr": "هاي روك",
        "nameFr": "Haute roche"
      },
      {
        "name": "Green Turtle Cay",
        "nameAr": "جرين تيرتل كاي",
        "nameFr": "Green Turtle Cay"
      },
      {
        "name": "Marsh Harbour",
        "nameAr": "مارش هاربر",
        "nameFr": "Marsh Harbour"
      },
      {
        "name": "Ragged Island",
        "nameAr": "جزيرة راكد",
        "nameFr": "Ile déchiquetée"
      },
      {
        "name": "Sandy Point",
        "nameAr": "ساندي بوينت",
        "nameFr": "Sandy Point"
      },
      {
        "name": "Inagua",
        "nameAr": "من Inagua",
        "nameFr": "Inagua"
      }
    ]
  },
  {
    "code": "TT",
    "name": "Trinidad and Tobago",
    "nameAr": "ترينيداد وتوباغو",
    "nameFr": "Trinidad and Tobago",
    "cities": [
            {
                  "name": "Arima",
                  "nameAr": "Arima",
                  "nameFr": "Arima"
            },
            {
                  "name": "Chaguanas",
                  "nameAr": "SelectNas",
                  "nameFr": "Chaguanas"
            },
            {
                  "name": "Couva-Tabaquite-Talparo",
                  "nameAr": "Couva-Tabaquite-Talparo",
                  "nameFr": "Couva-Tabaquite-Talparo"
            },
            {
                  "name": "Diego Martin",
                  "nameAr": "Diego Martin",
                  "nameFr": "Diego Martin"
            },
            {
                  "name": "Eastern Tobago",
                  "nameAr": "Eastern Tobago",
                  "nameFr": "Eastern Tobago"
            },
            {
                  "name": "Penal-Debe",
                  "nameAr": "Criminal-Debe",
                  "nameFr": "Penal-Debe"
            },
            {
                  "name": "Point Fortin",
                  "nameAr": "Point Fortin",
                  "nameFr": "Point Fortin"
            },
            {
                  "name": "Port of Spain",
                  "nameAr": "Port of Spain",
                  "nameFr": "Port of Spain"
            },
            {
                  "name": "Princes Town",
                  "nameAr": "Princes Town",
                  "nameFr": "Princes Town"
            },
            {
                  "name": "Rio Claro-Mayaro",
                  "nameAr": "Rio Claro-Mayaro",
                  "nameFr": "Rio Claro-Mayaro"
            },
            {
                  "name": "San Fernando",
                  "nameAr": "San Fernando",
                  "nameFr": "San Fernando"
            },
            {
                  "name": "San Juan-Laventille",
                  "nameAr": "For San Juan Lavent",
                  "nameFr": "San Juan-Laventille"
            },
            {
                  "name": "Sangre Grande",
                  "nameAr": "Big blood",
                  "nameFr": "Sangre Grande"
            },
            {
                  "name": "Siparia",
                  "nameAr": "Siparia",
                  "nameFr": "Siparia"
            },
            {
                  "name": "Tunapuna-Piarco",
                  "nameAr": "Tunapuna-Piarco",
                  "nameFr": "Tunapuna-Piarco"
            },
            {
                  "name": "Western Tobago",
                  "nameAr": "Western Tobago",
                  "nameFr": "Western Tobago"
            }
      ]
  },
  {
    "code": "TC",
    "name": "Turks and Caicos Islands",
    "nameAr": "جزر توركس وكايكوس",
    "nameFr": "Turks and Caicos Islands",
    "cities": [
            {
                  "name": "Grand Turk",
                  "nameAr": "Grand Turk",
                  "nameFr": "Grand Turk"
            },
            {
                  "name": "Middle Caicos",
                  "nameAr": "Middle Caicos",
                  "nameFr": "Middle Caicos"
            },
            {
                  "name": "North Caicos",
                  "nameAr": "North Caicos",
                  "nameFr": "North Caicos"
            },
            {
                  "name": "Providenciales",
                  "nameAr": "Providenciales",
                  "nameFr": "Providenciales"
            },
            {
                  "name": "Salt Cay",
                  "nameAr": "Salt Cay",
                  "nameFr": "Salt Cay"
            },
            {
                  "name": "South Caicos",
                  "nameAr": "South Caicos",
                  "nameFr": "South Caicos"
            }
      ]
  },
  {
    "code": "US",
    "name": "United States",
    "nameAr": "الولايات المتحدة",
    "nameFr": "United States",
    "cities": [
      {
        "name": "Alabama",
        "nameAr": "",
        "nameFr": "Alabama"
      },
      {
        "name": "Alaska",
        "nameAr": "",
        "nameFr": "Alaska"
      },
      {
        "name": "American Samoa",
        "nameAr": "",
        "nameFr": "American Samoa"
      },
      {
        "name": "Arizona",
        "nameAr": "",
        "nameFr": "Arizona"
      },
      {
        "name": "Arkansas",
        "nameAr": "",
        "nameFr": "Arkansas"
      },
      {
        "name": "California",
        "nameAr": "",
        "nameFr": "California"
      },
      {
        "name": "Colorado",
        "nameAr": "",
        "nameFr": "Colorado"
      },
      {
        "name": "Connecticut",
        "nameAr": "",
        "nameFr": "Connecticut"
      },
      {
        "name": "Delaware",
        "nameAr": "",
        "nameFr": "Delaware"
      },
      {
        "name": "District of Columbia",
        "nameAr": "",
        "nameFr": "District of Columbia"
      },
      {
        "name": "Florida",
        "nameAr": "",
        "nameFr": "Florida"
      },
      {
        "name": "Georgia",
        "nameAr": "",
        "nameFr": "Georgia"
      },
      {
        "name": "Guam",
        "nameAr": "",
        "nameFr": "Guam"
      },
      {
        "name": "Hawaii",
        "nameAr": "",
        "nameFr": "Hawaii"
      },
      {
        "name": "Idaho",
        "nameAr": "",
        "nameFr": "Idaho"
      },
      {
        "name": "Illinois",
        "nameAr": "",
        "nameFr": "Illinois"
      },
      {
        "name": "Indiana",
        "nameAr": "",
        "nameFr": "Indiana"
      },
      {
        "name": "Iowa",
        "nameAr": "",
        "nameFr": "Iowa"
      },
      {
        "name": "Kansas",
        "nameAr": "",
        "nameFr": "Kansas"
      },
      {
        "name": "Kentucky",
        "nameAr": "",
        "nameFr": "Kentucky"
      },
      {
        "name": "Louisiana",
        "nameAr": "",
        "nameFr": "Louisiana"
      },
      {
        "name": "Maine",
        "nameAr": "",
        "nameFr": "Maine"
      },
      {
        "name": "Maryland",
        "nameAr": "",
        "nameFr": "Maryland"
      },
      {
        "name": "Massachusetts",
        "nameAr": "",
        "nameFr": "Massachusetts"
      },
      {
        "name": "Michigan",
        "nameAr": "",
        "nameFr": "Michigan"
      },
      {
        "name": "Minnesota",
        "nameAr": "",
        "nameFr": "Minnesota"
      },
      {
        "name": "Mississippi",
        "nameAr": "",
        "nameFr": "Mississippi"
      },
      {
        "name": "Missouri",
        "nameAr": "",
        "nameFr": "Missouri"
      },
      {
        "name": "Montana",
        "nameAr": "",
        "nameFr": "Montana"
      },
      {
        "name": "Nebraska",
        "nameAr": "",
        "nameFr": "Nebraska"
      },
      {
        "name": "Nevada",
        "nameAr": "",
        "nameFr": "Nevada"
      },
      {
        "name": "New Hampshire",
        "nameAr": "",
        "nameFr": "New Hampshire"
      },
      {
        "name": "New Jersey",
        "nameAr": "",
        "nameFr": "New Jersey"
      },
      {
        "name": "New Mexico",
        "nameAr": "",
        "nameFr": "New Mexico"
      },
      {
        "name": "New York",
        "nameAr": "",
        "nameFr": "New York"
      },
      {
        "name": "North Carolina",
        "nameAr": "",
        "nameFr": "North Carolina"
      },
      {
        "name": "North Dakota",
        "nameAr": "",
        "nameFr": "North Dakota"
      },
      {
        "name": "Northern Mariana Islands",
        "nameAr": "",
        "nameFr": "Northern Mariana Islands"
      },
      {
        "name": "Ohio",
        "nameAr": "",
        "nameFr": "Ohio"
      },
      {
        "name": "Oklahoma",
        "nameAr": "",
        "nameFr": "Oklahoma"
      },
      {
        "name": "Oregon",
        "nameAr": "",
        "nameFr": "Oregon"
      },
      {
        "name": "Pennsylvania",
        "nameAr": "",
        "nameFr": "Pennsylvania"
      },
      {
        "name": "Puerto Rico",
        "nameAr": "",
        "nameFr": "Puerto Rico"
      },
      {
        "name": "Rhode Island",
        "nameAr": "",
        "nameFr": "Rhode Island"
      },
      {
        "name": "South Carolina",
        "nameAr": "",
        "nameFr": "South Carolina"
      },
      {
        "name": "South Dakota",
        "nameAr": "",
        "nameFr": "South Dakota"
      },
      {
        "name": "Tennessee",
        "nameAr": "",
        "nameFr": "Tennessee"
      },
      {
        "name": "Texas",
        "nameAr": "",
        "nameFr": "Texas"
      },
      {
        "name": "United States Minor Outlying Islands",
        "nameAr": "",
        "nameFr": "United States Minor Outlying Islands"
      },
      {
        "name": "United States Virgin Islands",
        "nameAr": "",
        "nameFr": "United States Virgin Islands"
      },
      {
        "name": "Utah",
        "nameAr": "",
        "nameFr": "Utah"
      },
      {
        "name": "Vermont",
        "nameAr": "",
        "nameFr": "Vermont"
      },
      {
        "name": "Virginia",
        "nameAr": "",
        "nameFr": "Virginia"
      },
      {
        "name": "Washington",
        "nameAr": "",
        "nameFr": "Washington"
      },
      {
        "name": "West Virginia",
        "nameAr": "",
        "nameFr": "West Virginia"
      },
      {
        "name": "Wisconsin",
        "nameAr": "",
        "nameFr": "Wisconsin"
      },
      {
        "name": "Wyoming",
        "nameAr": "",
        "nameFr": "Wyoming"
      }
    ]
  },
  {
    "code": "UM",
    "name": "United States Minor Outlying Islands",
    "nameAr": "جزر الولايات المتحدة النائية",
    "nameFr": "United States Minor Outlying Islands",
    "cities": [
      {
        "name": "Baker Island",
        "nameAr": "",
        "nameFr": "Baker Island"
      },
      {
        "name": "Howland Island",
        "nameAr": "",
        "nameFr": "Howland Island"
      },
      {
        "name": "Jarvis Island",
        "nameAr": "",
        "nameFr": "Jarvis Island"
      },
      {
        "name": "Johnston Atoll",
        "nameAr": "",
        "nameFr": "Johnston Atoll"
      },
      {
        "name": "Kingman Reef",
        "nameAr": "",
        "nameFr": "Kingman Reef"
      },
      {
        "name": "Midway Islands",
        "nameAr": "",
        "nameFr": "Midway Islands"
      },
      {
        "name": "Navassa Island",
        "nameAr": "",
        "nameFr": "Navassa Island"
      },
      {
        "name": "Palmyra Atoll",
        "nameAr": "",
        "nameFr": "Palmyra Atoll"
      },
      {
        "name": "Wake Island",
        "nameAr": "",
        "nameFr": "Wake Island"
      }
    ]
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "nameAr": "الأوروغواي",
    "nameFr": "Uruguay",
    "cities": [
            {
                  "name": "Artigas",
                  "nameAr": "Artigas",
                  "nameFr": "Artigas"
            },
            {
                  "name": "Canelones",
                  "nameAr": "Canelones",
                  "nameFr": "Canelones"
            },
            {
                  "name": "Cerro Largo",
                  "nameAr": "Cerro Largo",
                  "nameFr": "Cerro Largo"
            },
            {
                  "name": "Colonia",
                  "nameAr": "Colonia",
                  "nameFr": "Colonia"
            },
            {
                  "name": "Durazno",
                  "nameAr": "Durazno",
                  "nameFr": "Durazno"
            },
            {
                  "name": "Flores",
                  "nameAr": "Flores",
                  "nameFr": "Flores"
            },
            {
                  "name": "Florida",
                  "nameAr": "Florida",
                  "nameFr": "Florida"
            },
            {
                  "name": "Lavalleja",
                  "nameAr": "Lavalleja",
                  "nameFr": "Lavalleja"
            },
            {
                  "name": "Maldonado",
                  "nameAr": "Maldonado",
                  "nameFr": "Maldonado"
            },
            {
                  "name": "Montevideo",
                  "nameAr": "Montevideo",
                  "nameFr": "Montevideo"
            },
            {
                  "name": "Paysandú",
                  "nameAr": "Paysandú",
                  "nameFr": "Paysandú"
            },
            {
                  "name": "Río Negro",
                  "nameAr": "Río Negro",
                  "nameFr": "Río Negro"
            },
            {
                  "name": "Rivera",
                  "nameAr": "Rivera",
                  "nameFr": "Rivera"
            },
            {
                  "name": "Rocha",
                  "nameAr": "Rocha",
                  "nameFr": "Rocha"
            },
            {
                  "name": "Salto",
                  "nameAr": "Tacón",
                  "nameFr": "Salto"
            },
            {
                  "name": "San José",
                  "nameAr": "San José",
                  "nameFr": "San José"
            },
            {
                  "name": "Soriano",
                  "nameAr": "Soriano",
                  "nameFr": "Soriano"
            },
            {
                  "name": "Tacuarembó",
                  "nameAr": "Tacuarembó",
                  "nameFr": "Tacuarembó"
            },
            {
                  "name": "Treinta y Tres",
                  "nameAr": "Treinta y Tres",
                  "nameFr": "Treinta y Tres"
            }
      ]
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "nameAr": "فنزويلا",
    "nameFr": "Venezuela",
    "cities": [
            {
                  "name": "Amazonas",
                  "nameAr": "Amazonas",
                  "nameFr": "Amazonas"
            },
            {
                  "name": "Anzoátegui",
                  "nameAr": "Anzoátegui",
                  "nameFr": "Anzoátegui"
            },
            {
                  "name": "Apure",
                  "nameAr": "Apure",
                  "nameFr": "Apure"
            },
            {
                  "name": "Aragua",
                  "nameAr": "Aragua",
                  "nameFr": "Aragua"
            },
            {
                  "name": "Barinas",
                  "nameAr": "Barinas",
                  "nameFr": "Barinas"
            },
            {
                  "name": "Bolívar",
                  "nameAr": "Bolívar",
                  "nameFr": "Bolívar"
            },
            {
                  "name": "Carabobo",
                  "nameAr": "Carabobo",
                  "nameFr": "Carabobo"
            },
            {
                  "name": "Cojedes",
                  "nameAr": "Cojedes",
                  "nameFr": "Cojedes"
            },
            {
                  "name": "Delta Amacuro",
                  "nameAr": "Delta Amacuro",
                  "nameFr": "Delta Amacuro"
            },
            {
                  "name": "Distrito Capital",
                  "nameAr": "Distrito Capital",
                  "nameFr": "Distrito Capital"
            },
            {
                  "name": "Falcón",
                  "nameAr": "Falcón",
                  "nameFr": "Falcón"
            },
            {
                  "name": "Guárico",
                  "nameAr": "Guárico",
                  "nameFr": "Guárico"
            },
            {
                  "name": "La Guaira",
                  "nameAr": "La Guaira",
                  "nameFr": "La Guaira"
            },
            {
                  "name": "Lara",
                  "nameAr": "Lara",
                  "nameFr": "Lara"
            },
            {
                  "name": "Mérida",
                  "nameAr": "Mérida",
                  "nameFr": "Mérida"
            },
            {
                  "name": "Miranda",
                  "nameAr": "Miranda",
                  "nameFr": "Miranda"
            },
            {
                  "name": "Monagas",
                  "nameAr": "Monagas",
                  "nameFr": "Monagas"
            },
            {
                  "name": "Nueva Esparta",
                  "nameAr": "Nueva Esparta",
                  "nameFr": "Nueva Esparta"
            },
            {
                  "name": "Portuguesa",
                  "nameAr": "portugués",
                  "nameFr": "Portuguesa"
            },
            {
                  "name": "Sucre",
                  "nameAr": "Sucre",
                  "nameFr": "Sucre"
            },
            {
                  "name": "Táchira",
                  "nameAr": "Táchira",
                  "nameFr": "Táchira"
            },
            {
                  "name": "Trujillo",
                  "nameAr": "Trujillo",
                  "nameFr": "Trujillo"
            },
            {
                  "name": "Venezuela",
                  "nameAr": "Venezuela",
                  "nameFr": "Venezuela"
            },
            {
                  "name": "Yaracuy",
                  "nameAr": "Yaracuy",
                  "nameFr": "Yaracuy"
            },
            {
                  "name": "Zulia",
                  "nameAr": "Zulia",
                  "nameFr": "Zulia"
            }
      ]
  },
  {
    "code": "VG",
    "name": "Virgin Islands (British)",
    "nameAr": "جزر العذراء البريطانية",
    "nameFr": "Virgin Islands (British)",
    "cities": []
  },
  {
    "code": "VI",
    "name": "Virgin Islands (US)",
    "nameAr": "جزر العذراء الأمريكية",
    "nameFr": "Virgin Islands (US)",
    "cities": [
            {
                  "name": "Saint Croix",
                  "nameAr": "Holy cross",
                  "nameFr": "Saint Croix"
            },
            {
                  "name": "Saint John",
                  "nameAr": "Saint John",
                  "nameFr": "Saint John"
            },
            {
                  "name": "Saint Thomas",
                  "nameAr": "Saint Thomas",
                  "nameFr": "Saint Thomas"
            }
      ]
  }
];
